app.controller('reportViewerController', function ($rootScope, $scope, safeApply, systemService) {

  $scope.loading = false
  $scope.report_data = null
  $scope.reportParameters = {}
  $scope.dataTable = null // Store DataTable instance
  $scope.is_admin = false // access_level 1 - controls the admin-only toolbar button

  // Pulls in user info from the rootScope -> CRMController
  $rootScope.$watch('user_info', function () {
    $scope.user_info = $rootScope.user_info
    $scope.is_admin = !!$scope.user_info && $scope.user_info.access_level == 1
  }, true)

  // Format cell values for display
  $scope.formatCellValue = function (value) {
    if (value === null || value === undefined) {
      return '';
    }

    // Check if value is an object (including arrays)
    if (typeof value === 'object') {
      try {
        return JSON.stringify(value, null, 2);
      } catch (e) {
        return String(value);
      }
    }

    // Return non-object values as is
    return value;
  }

  /*
    Export buttons shared by the report table and the designer's test table.
    jszip (xlsx), pdfmake + vfs_fonts (pdf) and buttons.html5 are already
    loaded in index.html.
    `titleFn` is a function so the filename reflects the report at click time.
  */
  function exportButtons(titleFn, contextFn) {
    const exportOptions = { columns: ':visible' }
    const fileTitle = () => {
      const raw = (typeof titleFn === 'function' ? titleFn() : titleFn) || 'Report'
      // Keep filenames filesystem-safe.
      return String(raw).replace(/[\\/:*?"<>|]+/g, '-').trim() || 'Report'
    }

    /*
      Metadata shown in the print/PDF header and footer. contextFn is supplied
      per table so the designer's test output can be labelled differently from a
      live report run.
    */
    function reportContext() {
      const ctx = (typeof contextFn === 'function' ? contextFn() : {}) || {}
      const now = new Date()
      return {
        title: (typeof titleFn === 'function' ? titleFn() : titleFn) || 'Report',
        description: ctx.description || '',
        rows: ctx.rows || 0,
        columns: ctx.columns || 0,
        parameters: ctx.parameters || [],   // [{name, value}]
        filtered: ctx.filtered || false,
        totalRows: ctx.totalRows || 0,
        user: ($scope.user_info
          ? [$scope.user_info.first_name, $scope.user_info.last_name].filter(Boolean).join(' ')
          : '') || 'CRM User',
        dateText: now.toLocaleDateString('en-US', {
          weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
        }),
        timeText: now.toLocaleTimeString('en-US', {
          hour: 'numeric', minute: '2-digit', timeZoneName: 'short',
        }),
      }
    }

    return [
      {
        extend: 'csvHtml5',
        text: '<i class="fal fa-file-csv me-1"></i>.csv',
        titleAttr: 'Export to CSV',
        className: 'btn btn-sm rv-export-btn',
        title: fileTitle,
        exportOptions: exportOptions,
      },
      {
        extend: 'excelHtml5',
        text: '<i class="fal fa-file-excel me-1"></i>.xlsx',
        titleAttr: 'Export to Excel',
        className: 'btn btn-sm rv-export-btn',
        title: fileTitle,
        exportOptions: exportOptions,
      },
      {
        // Also gives the toolbar's Print button something to trigger -
        // '.buttons-print' previously matched nothing.
        extend: 'print',
        text: '<i class="fal fa-print me-1"></i>Print',
        titleAttr: 'Print',
        className: 'btn btn-sm rv-export-btn',
        title: '',            // suppressed - the custom header carries the title
        exportOptions: exportOptions,
        /*
          The print button opens a real window and copies our stylesheets into
          it, so `win` can be restyled freely. Everything below runs in that
          window, not the app.
        */
        customize: function (win) {
          const ctx = reportContext()
          const doc = win.document
          const esc = s => String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

          doc.title = ctx.title

          // Landscape, with margins that leave room for the running footer.
          const style = doc.createElement('style')
          style.appendChild(doc.createTextNode(`
            @page { size: landscape; margin: 12mm 10mm 16mm 10mm; }
            * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            body {
              font-family: -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
              font-size: 9px; color: #1f2933; margin: 0; padding: 0;
            }
            h1, .dt-print-title { display: none !important; }

            .rp-head {
              display: flex; align-items: flex-start; justify-content: space-between;
              gap: 18px; padding-bottom: 8px; margin-bottom: 10px;
              border-bottom: 2px solid #2b9cd3;
            }
            .rp-title { font-size: 15px; font-weight: 700; letter-spacing: -0.2px; }
            .rp-desc  { font-size: 9px; color: #64748b; margin-top: 2px; max-width: 620px; }
            .rp-brand { font-size: 11px; font-weight: 700; color: #2b9cd3; text-align: right; }
            .rp-meta  { font-size: 8.5px; color: #64748b; text-align: right; margin-top: 2px; line-height: 1.5; }

            .rp-facts {
              display: flex; flex-wrap: wrap; gap: 6px 8px; margin-bottom: 9px;
            }
            .rp-fact {
              font-size: 8px; border: 1px solid #dde5ee; border-radius: 9px;
              padding: 2px 8px; background: #f8fafc;
            }
            .rp-fact b { color: #1f2933; }
            .rp-fact-label {
              text-transform: uppercase; letter-spacing: 0.4px; color: #94a3b8;
              margin-right: 4px; font-weight: 700;
            }

            table { width: 100% !important; border-collapse: collapse; font-size: 8.5px; }
            thead { display: table-header-group; }   /* repeat header on every page */
            tfoot { display: table-footer-group; }
            tr { page-break-inside: avoid; }
            th {
              background: #eef4f9 !important; color: #1f2933;
              text-align: left; font-weight: 700; font-size: 8px;
              text-transform: uppercase; letter-spacing: 0.3px;
              padding: 5px 6px; border-bottom: 1.5px solid #b8cfe0;
            }
            td { padding: 4px 6px; border-bottom: 1px solid #eef2f7; vertical-align: top; }
            tbody tr:nth-child(even) td { background: #fafcfe !important; }

            .rp-foot {
              position: fixed; bottom: 4mm; left: 0; right: 0;
              display: flex; justify-content: space-between;
              font-size: 7.5px; color: #94a3b8;
              border-top: 1px solid #e2e8f0; padding-top: 3px;
            }
          `))
          doc.head.appendChild(style)

          // Facts row - only render what we actually know.
          const facts = []
          const fact = (label, value) =>
            '<span class="rp-fact"><span class="rp-fact-label">' + esc(label) +
            '</span><b>' + esc(value) + '</b></span>'

          facts.push(fact('Rows', Number(ctx.rows).toLocaleString('en-US')))
          if (ctx.filtered && ctx.totalRows > ctx.rows) {
            facts.push(fact('Filtered from', Number(ctx.totalRows).toLocaleString('en-US')))
          }
          if (ctx.columns) facts.push(fact('Columns', ctx.columns))
          ctx.parameters.forEach(pm => facts.push(fact(pm.name, pm.value)))

          const header =
            '<div class="rp-head">' +
              '<div>' +
                '<div class="rp-title">' + esc(ctx.title) + '</div>' +
                (ctx.description ? '<div class="rp-desc">' + esc(ctx.description) + '</div>' : '') +
              '</div>' +
              '<div>' +
                '<div class="rp-brand">PropertyTax.io CRM</div>' +
                '<div class="rp-meta">' +
                  esc(ctx.dateText) + ' &middot; ' + esc(ctx.timeText) + '<br>' +
                  'Run by ' + esc(ctx.user) +
                '</div>' +
              '</div>' +
            '</div>' +
            (facts.length ? '<div class="rp-facts">' + facts.join('') + '</div>' : '')

          const footer =
            '<div class="rp-foot">' +
              '<span>' + esc(ctx.title) + '</span>' +
              '<span>' + Number(ctx.rows).toLocaleString('en-US') + ' rows &middot; ' +
                esc(ctx.dateText) + ' ' + esc(ctx.timeText) + '</span>' +
              '<span>PropertyTax.io CRM &mdash; Confidential</span>' +
            '</div>'

          $(doc.body).prepend(header)
          $(doc.body).append(footer)
        },
      },
      {
        extend: 'pdfHtml5',
        text: '<i class="fal fa-file-pdf me-1"></i>.pdf',
        titleAttr: 'Export to PDF',
        className: 'btn btn-sm rv-export-btn',
        title: fileTitle,
        // Wide reports are unreadable in portrait.
        orientation: 'landscape',
        pageSize: 'LETTER',
        exportOptions: exportOptions,
        customize: function (doc) {
          const ctx = reportContext()

          doc.pageMargins = [22, 74, 22, 40]
          doc.defaultStyle.fontSize = 7
          doc.defaultStyle.color = '#1f2933'

          // Drop the plugin's default title block - replaced by the header below.
          doc.content = doc.content.filter(c => !c.text)

          const table = doc.content[0]
          if (table && table.table) {
            table.layout = {
              hLineWidth: i => (i <= 1 ? 1 : 0.5),
              vLineWidth: () => 0,
              hLineColor: i => (i <= 1 ? '#b8cfe0' : '#eef2f7'),
              paddingTop: () => 3,
              paddingBottom: () => 3,
              paddingLeft: () => 4,
              paddingRight: () => 4,
              // Zebra striping; row 0 is the header.
              fillColor: row => (row === 0 ? '#eef4f9' : (row % 2 === 0 ? '#fafcfe' : null)),
            }
            table.table.widths = Array(table.table.body[0].length).fill('*')
            // Repeat the header row on every page.
            table.table.headerRows = 1
            table.table.body[0].forEach(cell => {
              cell.fillColor = '#eef4f9'
              cell.color = '#1f2933'
              cell.bold = true
              cell.fontSize = 6.5
            })
          }

          const facts = ['Rows: ' + Number(ctx.rows).toLocaleString('en-US')]
          if (ctx.filtered && ctx.totalRows > ctx.rows) {
            facts.push('Filtered from ' + Number(ctx.totalRows).toLocaleString('en-US'))
          }
          if (ctx.columns) facts.push('Columns: ' + ctx.columns)
          ctx.parameters.forEach(pm => facts.push(pm.name + ': ' + pm.value))

          // Running header on every page.
          doc.header = function () {
            return {
              margin: [22, 18, 22, 0],
              stack: [
                {
                  columns: [
                    {
                      width: '*',
                      stack: [
                        { text: ctx.title, fontSize: 13, bold: true, color: '#1f2933' },
                        ctx.description
                          ? { text: ctx.description, fontSize: 7, color: '#64748b', margin: [0, 2, 0, 0] }
                          : {},
                      ],
                    },
                    {
                      width: 'auto',
                      alignment: 'right',
                      stack: [
                        { text: 'PropertyTax.io CRM', fontSize: 9, bold: true, color: '#2b9cd3' },
                        {
                          text: ctx.dateText + '  ·  ' + ctx.timeText,
                          fontSize: 6.5, color: '#64748b', margin: [0, 2, 0, 0],
                        },
                        { text: 'Run by ' + ctx.user, fontSize: 6.5, color: '#64748b' },
                      ],
                    },
                  ],
                },
                {
                  text: facts.join('     ·     '),
                  fontSize: 6.5, color: '#5e6e82', margin: [0, 6, 0, 4],
                },
                // Accent rule under the header.
                {
                  canvas: [{
                    type: 'line', x1: 0, y1: 0, x2: 744, y2: 0,
                    lineWidth: 1.5, lineColor: '#2b9cd3',
                  }],
                },
              ],
            }
          }

          // Running footer with page numbers.
          doc.footer = function (currentPage, pageCount) {
            return {
              margin: [22, 8, 22, 0],
              columns: [
                { text: ctx.title, fontSize: 6.5, color: '#94a3b8', width: '*' },
                {
                  text: 'Page ' + currentPage + ' of ' + pageCount,
                  fontSize: 6.5, color: '#94a3b8', alignment: 'center', width: 'auto',
                },
                {
                  text: 'PropertyTax.io CRM — Confidential',
                  fontSize: 6.5, color: '#94a3b8', alignment: 'right', width: '*',
                },
              ],
            }
          }
        },
      },
    ]
  }

  // Initialize DataTable
  function initializeDataTable(data) {
    // Destroy existing DataTable if it exists
    if ($scope.dataTable) {
      $scope.dataTable.destroy();
      $('#reportDataTable').empty();
    }

    if (!data || !data.data || data.data.length === 0) {
      return;
    }

    // Saved per-column settings for the report being viewed, when there are any.
    let savedCols = $scope.selectedReport ? $scope.selectedReport.column_config : null
    if (typeof savedCols === 'string') {
      try { savedCols = JSON.parse(savedCols) } catch (e) { savedCols = null }
    }
    if (!Array.isArray(savedCols)) savedCols = []

    // Prepare columns
    const columns = data.columns ? data.columns.map(col => {
      const cfg = savedCols.find(c => c.name === col) || {}
      const align = cfg.align || 'left'
      const stored = parseInt(cfg.width, 10) > 0 ? parseInt(cfg.width, 10) : 0
      // 0 means auto - size from content so fixed layout can't collapse it.
      const width = stored || autoWidthFor(col, data.data || [])
      return {
        title: col,
        data: col,
        width: width + 'px',
        className: `nowrap dt-head-${align} dt-body-${align}`,
        render: function (data, type, row) {
          if (type === 'display' || type === 'type') {
            return $scope.formatCellValue(data);
          }
          return data;
        },
        // Truncated cells keep their full value available on hover.
        createdCell: function (td) {
          const text = td.textContent || ''
          if (text !== '') td.setAttribute('title', text)
        }
      }
    }) : [];

    // Initialize DataTable with export buttons
    $scope.dataTable = $('#reportDataTable').DataTable({
      data: data.data,
      columns: columns,
      responsive: false, // Disable responsive to enable horizontal scrolling
      scrollX: true, // Enable horizontal scrolling
      // scrollY: '400px',
      scrollCollapse: true,
      paging: true,
      pageLength: 25,
      lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]],
      searching: true,
      ordering: true,
      info: true,
      autoWidth: false,
      // B renders the export buttons; without it the buttons exist but are
      // never placed in the DOM (the toolbar's trigger() calls silently no-op).
      dom: '<"top"<"dt-top-left"lB><"dt-top-right"f>>rt<"bottom"ip>',
      buttons: exportButtons(
        () => $scope.selectedReport ? $scope.selectedReport.title : 'Report',
        function () {
          const dt = $scope.dataTable
          // Row counts come from the table so they reflect any active search.
          const info = dt ? dt.page.info() : null
          const params = $scope.reportParameters || {}
          const fields = ($scope.selectedReport && $scope.selectedReport.fields) || []
          return {
            description: ($scope.selectedReport && $scope.selectedReport.description) || '',
            rows: info ? info.recordsDisplay : 0,
            totalRows: info ? info.recordsTotal : 0,
            filtered: !!(info && info.recordsDisplay !== info.recordsTotal),
            columns: dt ? dt.columns(':visible').count() : 0,
            // Show the parameter values the report was actually run with.
            parameters: fields
              .filter(f => f.field && params[f.field] !== undefined && params[f.field] !== null && params[f.field] !== '')
              .map(f => ({ name: f.name || f.field, value: params[f.field] })),
          }
        }
      ),
      language: {
        search: "Search records:",
        lengthMenu: "Show _MENU_ records per page",
        info: "Showing _START_ to _END_ of _TOTAL_ records",
        infoEmpty: "No records available",
        infoFiltered: "(filtered from _MAX_ total records)",
        paginate: {
          first: "First",
          last: "Last",
          next: "Next",
          previous: "Previous"
        }
      },
      // No _all className here - it would replace the per-column
      // nowrap/dt-head-*/dt-body-* classes set above.
    });

    // Declared widths need sWidth seeding before they take effect.
    primeColumnWidths($scope.dataTable);
    attachColumnHover($scope.dataTable);

    // Drag-to-resize. Widths persist only for admins via the designer's Fields
    // tab, so here the change is applied for the session only.
    attachColumnResizers($scope.dataTable, null);
  }

  /*
    With scrollX enabled DataTables renders the header in its own table inside
    .dataTables_scrollHead. That table keeps the widths it was built with, so a
    browser resize reflows the body but leaves the header misaligned.
    Debounced so dragging the window isn't janky.
  */
  let resizeTimer = null

  /*
    columns.adjust() alone does nothing here: _fnAdjustColumnSizing starts with
    `if (settings.oFeatures.bAutoWidth !== false)` and both tables are built
    with autoWidth:false, so the width recalculation is skipped and only the
    scroll redraw runs - leaving the header at its original widths.
    Flip the flag for the duration of the call, then restore it so initial
    sizing behaviour is unchanged.
  */
  function adjustOneTable(table) {
    if (!table) return
    try {
      const settings = table.settings()[0]
      const previous = settings.oFeatures.bAutoWidth
      settings.oFeatures.bAutoWidth = true
      table.columns.adjust()
      settings.oFeatures.bAutoWidth = previous
    } catch (e) {
      // Table was destroyed between the resize and this callback.
      console.log('adjustOneTable-> skipped :>> ', e && e.message)
    }
  }

  function adjustTables() {
    // enforceColumnWidths adjusts AND restores explicit widths, which a bare
    // adjust would recompute away.
    enforceColumnWidths($scope.dataTable)
    enforceColumnWidths(designerTestTable)
  }

  function onWindowResize() {
    if (resizeTimer) clearTimeout(resizeTimer)
    resizeTimer = setTimeout(adjustTables, 120)
  }

  $(window).on('resize.reportViewer', onWindowResize)

  // The left menu collapsing changes the content width without a window resize.
  $(document).on('click.reportViewer', '.toggle-icon, .mobile-toggle-menu', function () {
    // Wait for the sidebar transition to settle before measuring.
    setTimeout(adjustTables, 320)
  })

  $scope.$on('$destroy', function () {
    if (resizeTimer) clearTimeout(resizeTimer)
    $(window).off('resize.reportViewer')
    $(document).off('click.reportViewer')
  })

  // Button actions for header buttons
  $scope.buttonAction = function (action) {
    switch (action) {
      case 'refresh':
        if ($scope.selectedReport) {
          // Re-run the current report
          runReport($scope.selectedReport, $scope.reportParameters || {});
        }
        break;
      case 'close':
        // Clear the current report
        $scope.report_data = null;
        $scope.selectedReport = null;
        if ($scope.dataTable) {
          $scope.dataTable.destroy();
          $('#reportDataTable').empty();
          $scope.dataTable = null;
        }
        safeApply($scope);
        break;
      case 'print':
        if ($scope.dataTable) {
          $scope.dataTable.button('.buttons-print').trigger();
        }
        break;
      case 'export_csv':
        if ($scope.dataTable) {
          $scope.dataTable.button('.buttons-csv').trigger();
        }
        break;
      case 'export_xlsx':
        if ($scope.dataTable) {
          $scope.dataTable.button('.buttons-excel').trigger();
        }
        break;
      case 'export_pdf':
        if ($scope.dataTable) {
          $scope.dataTable.button('.buttons-pdf').trigger();
        }
        break;
      case 'admin':
        // Open the currently selected report in the designer, when there is one.
        if ($scope.selectedReport) {
          $scope.openDesigner($scope.selectedReport.id)
        } else {
          toastr.info('Choose a report from the dropdown to edit it.', 'Report Designer')
        }
        break;
    }
  }

  // Report Designer ---------------------------------------------------------------
  //#region - Report Designer (admin only)

  let sqlEditor = null       // CodeMirror instance
  let designerTestTable = null
  let descriptionModal = null
  let syncTimer = null

  $scope.designer = {
    report: null,      // the report being edited
    query: '',         // working copy of the SQL
    fields: [],        // working copy of the parameter definitions
    title: '',         // working copy of the report name
    description: '',   // working copy of the description
    titleDraft: '',        // in-progress rename, applied on the check icon
    descriptionDraft: '',  // in-progress description, applied on modal Save
    editingTitle: false,
    testParams: {},    // values used for the Test run only - never saved
    columns: [],       // Fields tab: per-result-column alignment / formatting
    activeTab: 'params',
    collapsed: { query: false, params: false, results: false },
    original: null,    // snapshot used for dirty-checking / revert
    testing: false,
    saving: false,
    testRan: false,
    testData: null,
    testError: null,
    testInfo: null,
  }

  // Deep-ish copy so edits don't mutate the report in $scope.reports.
  function cloneFields(fields) {
    if (!Array.isArray(fields)) return []
    return fields.map(f => ({
      name: f.name || '',
      field: f.field || '',
      type: f.type || 'TEXT',
      required: !!f.required,
      default_value: (f.default_value === undefined || f.default_value === null) ? '' : f.default_value,
    }))
  }

  /*
    Switching or closing the designer with unsaved edits would silently discard
    them, so those paths route through a confirm modal first. pendingAction
    holds what to do once the user chooses.
  */
  let pendingAction = null
  let unsavedModal = null

  $scope.unsavedPrompt = { target_title: '', saving: false }

  function showUnsavedModal(action, targetTitle) {
    pendingAction = action
    $scope.unsavedPrompt.target_title = targetTitle || ''
    $scope.unsavedPrompt.saving = false
    const el = document.getElementById('unsavedChangesModal')
    if (!el) {
      // No modal in the DOM - fail safe by keeping the edits rather than losing them.
      pendingAction = null
      return
    }
    unsavedModal = bootstrap.Modal.getInstance(el) || new bootstrap.Modal(el)
    unsavedModal.show()
    safeApply($scope)
  }

  function hideUnsavedModal() {
    const el = document.getElementById('unsavedChangesModal')
    if (!el) return
    const instance = bootstrap.Modal.getInstance(el)
    if (instance) instance.hide()
  }

  // Save, then continue to whatever the user was trying to do.
  $scope.unsavedSaveAndContinue = async function () {
    $scope.unsavedPrompt.saving = true
    safeApply($scope)

    const ok = await $scope.saveDesignerReport()
    $scope.unsavedPrompt.saving = false

    if (ok === false) {
      // Save failed - stay put so the edits aren't lost.
      safeApply($scope)
      return
    }
    const action = pendingAction
    pendingAction = null
    hideUnsavedModal()
    if (action) action()
  }

  $scope.unsavedDiscardAndContinue = function () {
    const action = pendingAction
    pendingAction = null
    // Clear the baseline so the reopen doesn't re-trigger the prompt.
    $scope.designer.original = null
    hideUnsavedModal()
    if (action) action()
  }

  $scope.unsavedCancel = function () {
    pendingAction = null
    hideUnsavedModal()
  }

  $scope.openDesigner = function (report_id) {
    if (!$scope.is_admin) return
    if (report_id === '' || report_id === null || report_id === undefined) {
      $scope.closeDesigner()
      return
    }

    // Switching away from a report with pending edits - ask first.
    if ($scope.designer.report && $scope.designer.report.id != report_id && $scope.designerIsDirty()) {
      const target = ($scope.reports || []).find(r => r.id == report_id)
      showUnsavedModal(() => openDesignerNow(report_id), target ? target.title : '')
      return
    }

    openDesignerNow(report_id)
  }

  function openDesignerNow(report_id) {
    const report = ($scope.reports || []).find(r => r.id == report_id)
    if (!report) {
      console.log('openDesigner-> report not found :>> ', report_id)
      return
    }

    // z_reports.fields is a JSON column - may arrive as an array or a JSON string.
    let fields = report.fields
    if (typeof fields === 'string') {
      try { fields = JSON.parse(fields) } catch (e) { fields = [] }
    }

    $scope.designerReportId = report.id
    $scope.designer.report = report
    $scope.designer.query = report.query || ''
    $scope.designer.fields = cloneFields(fields)
    $scope.designer.title = report.title || ''
    $scope.designer.description = report.description || ''
    $scope.designer.editingTitle = false
    $scope.designer.titleDraft = ''
    $scope.designer.descriptionDraft = ''
    $scope.designer.collapsed = { query: false, params: false, results: false }
    $scope.designer.activeTab = 'params'

    // column_config is a JSON column - may arrive as an array or a JSON string.
    // Saved rows already carry their metadata, so use them as-is rather than
    // synthesising it (which previously showed the alias in the Field column).
    let column_config = report.column_config
    if (typeof column_config === 'string') {
      try { column_config = JSON.parse(column_config) } catch (e) { column_config = [] }
    }
    $scope.designer.columns = (Array.isArray(column_config) ? column_config : []).map(c => ({
      name: c.name,
      org_name: c.org_name || '',
      table: c.table || '',
      aliased: !!c.aliased,
      data_type: c.data_type || 'STRING',
      align: c.align || 'left',
      format: c.format || 'none',
      // Pixel width; 0/absent means auto-size.
      width: parseInt(c.width, 10) > 0 ? parseInt(c.width, 10) : 0,
      visible: c.visible === undefined ? true : !!c.visible,
    }))

    $scope.designer.original = {
      query: report.query || '',
      fields: angular.toJson(cloneFields(fields)),
      title: report.title || '',
      description: report.description || '',
      columns: angular.toJson(cloneColumns($scope.designer.columns)),
    }

    // Seed the test values from each parameter's default.
    $scope.designer.testParams = {}
    $scope.designer.fields.forEach(f => {
      if (f.field) $scope.designer.testParams[f.field] = f.default_value
    })

    // Clear any previous test run.
    destroyDesignerTestTable()
    $scope.designer.testRan = false
    $scope.designer.testData = null
    $scope.designer.testError = null
    $scope.designer.testInfo = null

    // Flag-only on open: mark unused params without adding rows, so merely
    // viewing a report never shows it as having unsaved changes.
    syncFieldsFromQuery(true)

    safeApply($scope)
    mountSqlEditor()

    // Table names for autocomplete (cached server-side, ~14 KB once).
    loadSchemaTableNames()
  }

  $scope.closeDesigner = function () {
    // Closing discards the working copy just as switching does - ask first.
    if ($scope.designer.report && $scope.designerIsDirty()) {
      showUnsavedModal(() => closeDesignerNow(), '')
      return
    }
    closeDesignerNow()
  }

  function closeDesignerNow() {
    if (syncTimer) { clearTimeout(syncTimer); syncTimer = null }
    destroySqlEditor()
    destroyDesignerTestTable()
    $scope.designer.report = null
    $scope.designer.query = ''
    $scope.designer.fields = []
    $scope.designer.title = ''
    $scope.designer.description = ''
    $scope.designer.titleDraft = ''
    $scope.designer.descriptionDraft = ''
    $scope.designer.editingTitle = false
    $scope.designer.testParams = {}
    $scope.designer.columns = []
    $scope.designer.activeTab = 'params'
    $scope.designer.original = null
    $scope.designer.testRan = false
    $scope.designer.testData = null
    $scope.designer.testError = null
    $scope.designer.testInfo = null
    $scope.designerReportId = ''
    safeApply($scope)
  }

  $scope.designerIsDirty = function () {
    if (!$scope.designer.original) return false
    // Compare through cloneFields so UI-only keys (e.g. the `unused` flag) are
    // stripped from both sides - the snapshot is stored cloned, so comparing the
    // raw live rows would always differ and pin the Save button to "dirty".
    return $scope.designer.query !== $scope.designer.original.query
      || angular.toJson(cloneFields($scope.designer.fields)) !== $scope.designer.original.fields
      || $scope.designer.title !== $scope.designer.original.title
      || $scope.designer.description !== $scope.designer.original.description
      || angular.toJson(cloneColumns($scope.designer.columns)) !== ($scope.designer.original.columns || '[]')
  }

  $scope.revertDesigner = function () {
    if (!$scope.designer.original) return
    $scope.designer.query = $scope.designer.original.query
    try {
      $scope.designer.fields = JSON.parse($scope.designer.original.fields)
    } catch (e) {
      $scope.designer.fields = []
    }
    $scope.designer.title = $scope.designer.original.title
    $scope.designer.description = $scope.designer.original.description
    $scope.designer.editingTitle = false
    // Restore align/format onto the live columns, keeping the metadata
    // (table, data_type) that only a Test run can supply.
    try {
      const savedCols = JSON.parse($scope.designer.original.columns || '[]')
      $scope.designer.columns = ($scope.designer.columns || []).map(c => {
        const prev = savedCols.find(s => s.name === c.name)
        return prev ? angular.extend({}, c, { align: prev.align, format: prev.format, visible: prev.visible }) : c
      })
    } catch (e) {
      console.log('revertDesigner-> column restore failed :>> ', e)
    }
    if (sqlEditor) sqlEditor.setValue($scope.designer.query)
    // Restored rows come from the cloned snapshot, so re-derive the unused flags.
    syncFieldsFromQuery(true)
    safeApply($scope)
  }

  // SQL autocomplete ---------------------------------------------------------------
  /*
    sql-hint takes a `tables` map of { tableName: [columns] }. Table names are
    loaded once; a table's columns are fetched the first time the user types
    "<table>." or "<alias>." - so we never ship all 11k columns.

    Aliases resolve through sql-hint's own findTableByAlias, which scans the
    query for "<table> <alias>" - but it can only match a table already present
    in the map, so an alias lookup also triggers a fetch for its real table.
  */
  const schemaTables = {}       // { table: [ {text, displayText, columnName, type} ] }
  let schemaTableNames = []
  const schemaPending = {}      // in-flight guards, so one fetch per table

  async function loadSchemaTableNames() {
    if (schemaTableNames.length || !$scope.is_admin) return
    try {
      const result = await systemService.functionCall({
        type: "getSchemaTables",
        user_id: $scope.user_info ? $scope.user_info.id : null,
        url_password: $scope.user_info ? $scope.user_info.url_password : null,
      })
      if (!result.data.success) return
      schemaTableNames = result.data.data.tables || []
      // Seed every table with an empty column list so table names complete and
      // alias resolution can find them; columns arrive on demand.
      schemaTableNames.forEach(name => {
        if (!schemaTables[name]) schemaTables[name] = []
      })
    } catch (e) {
      console.log('loadSchemaTableNames-> error :>> ', e)
    }
  }

  async function loadSchemaColumns(table) {
    if (!table || !$scope.is_admin) return
    if (schemaTables[table] && schemaTables[table].length) return
    if (schemaPending[table]) return
    schemaPending[table] = true

    try {
      const result = await systemService.functionCall({
        type: "getSchemaColumns",
        user_id: $scope.user_info ? $scope.user_info.id : null,
        url_password: $scope.user_info ? $scope.user_info.url_password : null,
        table: table,
      })
      if (result.data.success) {
        const cols = result.data.data.columns || []
        // sql-hint accepts objects with text/displayText, which lets the type
        // show in the dropdown while only the name is inserted.
        schemaTables[table] = cols.map(c => {
          const type = c.full_type || c.type
          return {
            text: c.name,
            displayText: c.name,
            columnName: c.name,
            className: 'rv-hint-column',
            // show-hint calls render() per row, which lets the type sit beside
            // the name while only `text` is inserted into the query.
            render: function (el) {
              const nameEl = document.createElement('span')
              nameEl.className = 'rv-hint-name'
              nameEl.textContent = c.name
              el.appendChild(nameEl)

              if (c.key === 'PRI') {
                const keyEl = document.createElement('span')
                keyEl.className = 'rv-hint-key'
                keyEl.textContent = 'PK'
                el.appendChild(keyEl)
              }

              const typeEl = document.createElement('span')
              typeEl.className = 'rv-hint-type'
              typeEl.textContent = type
              el.appendChild(typeEl)
            },
          }
        })
        // Re-open the hint list so the freshly loaded columns appear.
        if (sqlEditor && sqlEditor.hasFocus()) showSqlHint()
      }
    } catch (e) {
      console.log('loadSchemaColumns-> error :>> ', e)
    }
    delete schemaPending[table]
  }

  // The identifier immediately before the cursor's trailing dot, if any.
  function tableTokenBeforeDot(cm) {
    const cursor = cm.getCursor()
    const line = cm.getLine(cursor.line) || ''
    const upToCursor = line.slice(0, cursor.ch)
    const m = /([A-Za-z_][A-Za-z0-9_$]*)\.[A-Za-z0-9_$]*$/.exec(upToCursor)
    return m ? m[1] : null
  }

  /*
    Resolves an alias to its real table.
    Anchored to FROM/JOIN so it can't match the alias in a SELECT list - e.g.
    "SELECT p.id ... FROM z_properties p" would otherwise match "SELECT p" and
    look up a table called SELECT.
  */
  function resolveAlias(name) {
    if (!name) return null
    if (schemaTables[name]) return name
    const sql = sqlEditor ? sqlEditor.getValue() : ''

    const re = new RegExp(
      '\\b(?:FROM|JOIN)\\s+([A-Za-z_][A-Za-z0-9_$]*)\\s+(?:AS\\s+)?' + reEscape(name) + '\\b',
      'ig'
    )
    let m
    while ((m = re.exec(sql)) !== null) {
      if (schemaTables[m[1]]) return m[1]
    }
    return null
  }

  function showSqlHint() {
    if (!sqlEditor || typeof CodeMirror === 'undefined' || !CodeMirror.hint || !CodeMirror.hint.sql) return
    sqlEditor.showHint({
      hint: CodeMirror.hint.sql,
      completeSingle: false,
      tables: schemaTables,
    })
  }

  // Fetches columns on demand, then opens the dropdown.
  function maybeAutocomplete(cm) {
    const token = tableTokenBeforeDot(cm)
    if (token) {
      const table = resolveAlias(token)
      if (table && (!schemaTables[table] || !schemaTables[table].length)) {
        loadSchemaColumns(table)   // async; re-opens the hint when it lands
        return
      }
    }
    showSqlHint()
  }

  // SQL formatting -----------------------------------------------------------------
  /*
    Pretty-prints the query with sql-formatter (MySQL dialect), keywords upper.

    paramTypes is required: {{name}} is not valid SQL, and without declaring it
    as a custom parameter type the formatter throws a parse error and refuses to
    format at all. (sql-formatter v4 is worse - it silently rewrites {{x}} to
    "{ { x } }", corrupting every parameterised report.)

    Manual only - nothing formats on save or on load.
  */
  /*
    sql-formatter's keywordCase:'upper' covers clause and logical keywords
    (SELECT/FROM/WHERE/AND/JOIN/GROUP BY) but leaves operator words as typed -
    "not in", "is null", "like" stay lower case. This finishes the job.

    String literals, backtick identifiers and comments are masked first so a
    value like 'not in stock' or a column named `like_count` is never touched.
  */
  const OPERATOR_WORDS = [
    'NOT IN', 'NOT LIKE', 'NOT BETWEEN', 'NOT EXISTS', 'IS NOT NULL', 'IS NULL',
    'IN', 'LIKE', 'BETWEEN', 'EXISTS', 'IS', 'AND', 'OR', 'NOT',
    'ASC', 'DESC', 'AS', 'DISTINCT', 'CASE', 'WHEN', 'THEN', 'ELSE', 'END',
    'NULL', 'TRUE', 'FALSE', 'INTERVAL', 'ON', 'USING',
  ]

  function upperCaseOperatorWords(sql) {
    const masked = []
    // Mask '...' strings, "..." strings, `identifiers`, -- line and /* */ comments.
    let work = sql.replace(
      /('(?:[^'\\]|\\.|'')*'|"(?:[^"\\]|\\.)*"|`[^`]*`|--[^\n]*|\/\*[\s\S]*?\*\/)/g,
      function (m) {
        masked.push(m)
        return '@@RVMASK' + (masked.length - 1) + 'RVMASK@@'
      }
    )

    // Longest first, so "IS NOT NULL" wins over "IS" and "NOT".
    OPERATOR_WORDS.slice()
      .sort((a, b) => b.length - a.length)
      .forEach(word => {
        const pattern = word.replace(/ /g, '\\s+')
        work = work.replace(new RegExp('\\b' + pattern + '\\b', 'gi'), word)
      })

    // Restore the masked runs.
    return work.replace(/@@RVMASK(\d+)RVMASK@@/g, (m, i) => masked[Number(i)])
  }

  $scope.formatDesignerQuery = function () {
    if (!sqlEditor) return

    if (typeof sqlFormatter === 'undefined' || !sqlFormatter.format) {
      toastr.error('The SQL formatter did not load.', 'Format', { timeOut: 6000 })
      return
    }

    const original = sqlEditor.getValue()
    if (!original || original.trim() === '') return

    try {
      const formatted = sqlFormatter.format(original, {
        language: 'mysql',
        tabWidth: 2,
        keywordCase: 'upper',
        linesBetweenQueries: 1,
        // Keeps {{placeholder}} intact instead of failing to parse.
        paramTypes: { custom: [{ regex: '\\{\\{[A-Za-z0-9_]+\\}\\}' }] },
      })

      if (!formatted || formatted.trim() === '') {
        toastr.warning('Formatting produced no output - query left unchanged.', 'Format')
        return
      }

      const cased = upperCaseOperatorWords(formatted)

      if (cased === original) {
        toastr.info('Already formatted.', 'Format', { timeOut: 2000 })
        return
      }

      // Preserve the cursor position where possible, and keep this in the undo
      // history so Ctrl-Z steps back through it.
      const cursor = sqlEditor.getCursor()
      sqlEditor.setValue(cased)
      sqlEditor.setCursor(cursor)
      // setValue fires 'change', which updates designer.query and the dirty flag.
      toastr.success('Query formatted.', 'Format', { timeOut: 2000 })
    } catch (error) {
      // A parse error means the SQL is genuinely malformed - leave it alone
      // rather than writing back something mangled.
      const detail = (error && error.message ? String(error.message) : '').split('\n')[0]
      console.log('formatDesignerQuery-> error :>> ', error)
      toastr.error(detail || 'Could not format this query.', 'Format', { timeOut: 8000 })
    }
  }

  // Parameter auto-discovery -------------------------------------------------------
  // Placeholders must match what the server substitutes: {{name}} with no
  // surrounding whitespace (see reporting_query_sql).
  const PLACEHOLDER_RE = /\{\{([A-Za-z0-9_]+)\}\}/g

  /*
    Strips SQL comments so placeholders inside them don't count as live.
    The server substitutes them regardless, but a commented-out line has no
    effect on the result - so those parameters really are unused.
    Replaced with spaces rather than removed, to keep offsets stable.
  */
  function stripSqlComments(sql) {
    let out = String(sql || '')

    // Block comments first, so a "--" inside one isn't treated as a line comment.
    out = out.replace(/\/\*[\s\S]*?\*\//g, m => m.replace(/[^\n]/g, ' '))

    /*
      Line comments: MySQL's "#" form, and "--" ONLY when followed by
      whitespace or at end of line. Bare "--" is not a comment in MySQL - it
      parses as a double negative, so "SELECT 5--3" returns 8 and "SELECT 1
      --comment" is a syntax error. Verified against the live server.
      Quoted strings are skipped so a literal like '-- x' isn't treated as one.
    */
    out = out.split('\n').map(line => {
      let inSingle = false, inDouble = false, inBacktick = false
      for (let i = 0; i < line.length; i++) {
        const ch = line[i]
        if (ch === "'" && !inDouble && !inBacktick) inSingle = !inSingle
        else if (ch === '"' && !inSingle && !inBacktick) inDouble = !inDouble
        else if (ch === '`' && !inSingle && !inDouble) inBacktick = !inBacktick
        else if (!inSingle && !inDouble && !inBacktick) {
          if (ch === '#') return line.slice(0, i)
          if (ch === '-' && line[i + 1] === '-') {
            const next = line[i + 2]
            // Comment only if "--" is followed by whitespace or ends the line.
            if (next === undefined || next === ' ' || next === '\t' || next === '\r') {
              return line.slice(0, i)
            }
            // Otherwise it's an operator - step past it and keep scanning.
            i++
          }
        }
      }
      return line
    }).join('\n')

    return out
  }

  function placeholdersInQuery(sql) {
    const found = []
    let m
    // Comment-stripped, so a placeholder only counts when it can actually run.
    const active = stripSqlComments(sql)
    PLACEHOLDER_RE.lastIndex = 0
    while ((m = PLACEHOLDER_RE.exec(active)) !== null) {
      if (found.indexOf(m[1]) === -1) found.push(m[1])
    }
    return found
  }

  // Turns a placeholder name into a readable default label: limit_count -> Limit Count
  function labelFromField(field) {
    return String(field)
      .replace(/_/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase())
  }

  /*
    Adds a row for any placeholder in the query that isn't declared yet, and
    marks declared params that no longer appear as unused. Never deletes a row -
    report 1 ships with declared-but-unused params and losing them on a typo
    would be destructive.
  */
  function syncFieldsFromQuery(flagOnly) {
    if (!$scope.designer.report) return 0

    const inQuery = placeholdersInQuery($scope.designer.query)
    let added = 0

    inQuery.forEach(name => {
      const exists = $scope.designer.fields.some(f => f.field === name)
      // flagOnly is used on open so simply viewing a report never marks it dirty.
      if (!exists && !flagOnly) {
        $scope.designer.fields.push({
          name: labelFromField(name),
          field: name,
          type: 'TEXT',
          required: false,
          default_value: '',
        })
        added++
      }
    })

    // Flag rows whose placeholder is no longer in the SQL (kept, not removed).
    $scope.designer.fields.forEach(f => {
      f.unused = !!f.field && inQuery.indexOf(f.field) === -1
    })

    if (added > 0) {
      // Seed test values for the new rows.
      $scope.designer.fields.forEach(f => {
        if (f.field && $scope.designer.testParams[f.field] === undefined) {
          $scope.designer.testParams[f.field] = f.default_value
        }
      })
      // A newly-detected parameter is easy to miss if the section is collapsed.
      if ($scope.designer.collapsed.params) $scope.designer.collapsed.params = false
    }

    return added
  }
  $scope.syncFieldsFromQuery = syncFieldsFromQuery

  $scope.hasUnusedFields = function () {
    return ($scope.designer.fields || []).some(f => f.unused)
  }

  $scope.unusedFieldCount = function () {
    return ($scope.designer.fields || []).filter(f => f.unused).length
  }

  /*
    Drops every parameter the query no longer references. Only marks the form
    dirty - nothing is written until Save, so this stays undoable via Revert.
  */
  $scope.removeUnusedFields = function () {
    const fields = $scope.designer.fields || []
    const removed = fields.filter(f => f.unused)
    if (!removed.length) return

    $scope.designer.fields = fields.filter(f => !f.unused)

    // Drop their test values too, so a stale entry can't be sent on the next run.
    removed.forEach(f => {
      if (f.field) delete $scope.designer.testParams[f.field]
    })

    toastr.success(
      `${removed.length} unused parameter${removed.length === 1 ? '' : 's'} removed. Save to keep the change.`,
      'Parameters',
      { timeOut: 4000 }
    )
    safeApply($scope)
  }

  // True while a report is open in the designer - locks the sidebar list.
  $scope.designerIsOpen = function () {
    return !!($scope.is_admin && $scope.designer && $scope.designer.report)
  }

  // Fields tab ---------------------------------------------------------------------
  // Formatting options offered per data type bucket.
  $scope.formatOptions = {
    INTEGER: ['none', 'integer', 'comma', 'currency', 'percent'],
    DECIMAL: ['none', 'comma', 'currency', 'percent', 'decimal_1', 'decimal_2'],
    DATE: ['none', 'date_mdy', 'date_ymd', 'date_long'],
    DATETIME: ['none', 'date_mdy', 'datetime_mdy', 'date_long', 'time_only'],
    TIME: ['none', 'time_only'],
    STRING: ['none', 'upper', 'lower', 'title'],
    TEXT: ['none', 'upper', 'lower', 'title'],
    JSON: ['none'],
  }

  $scope.formatLabels = {
    none: 'None',
    integer: '1234',
    comma: '1,234',
    currency: '$1,234.00',
    percent: '12.34%',
    decimal_1: '1234.5',
    decimal_2: '1234.50',
    date_mdy: 'MM/DD/YYYY',
    date_ymd: 'YYYY-MM-DD',
    date_long: 'Mon DD, YYYY',
    datetime_mdy: 'MM/DD/YYYY HH:mm',
    time_only: 'HH:mm:ss',
    upper: 'UPPERCASE',
    lower: 'lowercase',
    title: 'Title Case',
  }

  $scope.formatsForType = function (data_type) {
    return $scope.formatOptions[data_type] || $scope.formatOptions.STRING
  }

  // Numeric columns read better right-aligned; that's the suggested default.
  function defaultAlignFor(data_type) {
    return (data_type === 'INTEGER' || data_type === 'DECIMAL') ? 'right' : 'left'
  }

  /*
    Reconciles the saved column_config with the columns the query actually
    returns. Settings are matched by column name, so renaming an AS alias
    starts that column fresh rather than silently keeping stale formatting.
  */
  function mergeColumnConfig(metaColumns, saved) {
    const savedList = Array.isArray(saved) ? saved : []
    return (metaColumns || []).map(meta => {
      const prev = savedList.find(c => c.name === meta.name) || {}
      return {
        // Metadata always comes from the live query - a query edit can change
        // a column's source table or type, so fresh values win over saved ones.
        name: meta.name,
        org_name: meta.org_name || '',
        table: meta.table || '',
        aliased: !!meta.aliased,
        // The database is the authority on type - a Test run always refreshes
        // it. Keeping the saved value let a stale STRING (written before type
        // detection existed) permanently mask the real type.
        data_type: meta.data_type || 'STRING',
        align: prev.align || defaultAlignFor(meta.data_type),
        format: prev.format || 'none',
        // Width is a user choice - always preserved across Test runs.
        width: parseInt(prev.width, 10) > 0 ? parseInt(prev.width, 10) : 0,
        visible: prev.visible === undefined ? true : !!prev.visible,
      }
    })
  }

  /*
    Shape persisted to z_reports.column_config. The discovered metadata
    (org_name / table / aliased / data_type) is stored too, so reopening a
    report shows the real field names and types without needing a Test run.
  */
  function cloneColumns(columns) {
    if (!Array.isArray(columns)) return []
    return columns.map(c => ({
      name: c.name,
      org_name: c.org_name || '',
      table: c.table || '',
      aliased: !!c.aliased,
      data_type: c.data_type || 'STRING',
      align: c.align || 'left',
      format: c.format || 'none',
      // Pixel width; 0 means auto. Must be included here or the dirty check
      // and the saved payload both silently drop it.
      width: parseInt(c.width, 10) > 0 ? parseInt(c.width, 10) : 0,
      visible: c.visible === undefined ? true : !!c.visible,
    }))
  }

  // Keeps the format valid when the user hasn't run a test since changing type.
  $scope.onColumnTypeChange = function (col) {
    const allowed = $scope.formatsForType(col.data_type)
    if (allowed.indexOf(col.format) === -1) col.format = 'none'
  }

  $scope.setDesignerTab = function (tab) {
    $scope.designer.activeTab = tab
  }

  $scope.applyAlignToAll = function (align) {
    ($scope.designer.columns || []).forEach(c => { c.align = align })
  }

  // Typing a width in the Fields tab pushes it straight to the test table.
  $scope.onColumnWidthChange = function (col) {
    const px = parseInt(col.width, 10)
    col.width = px > 0 ? px : 0
    pushWidthToTestTable(col)
  }

  $scope.clearColumnWidth = function (col) {
    col.width = 0
    pushWidthToTestTable(col)
  }

  function pushWidthToTestTable(col) {
    if (!designerTestTable) return
    const visible = ($scope.designer.columns || []).filter(c => c.visible !== false)
    const index = visible.findIndex(c => c.name === col.name)
    if (index > -1) applyColumnWidth(designerTestTable, index, col.width)
  }

  /*
    Column resizing.
    DataTables has no built-in resizer, and third-party ones fight scrollX
    (which renders the header in its own table). This attaches a slim grip to
    each header cell of .dataTables_scrollHead and, on drag, writes the new
    width back through the DataTables API so header and body stay in step.
    onCommit(name, px) lets the Fields tab persist the result.
  */
  const MIN_COL_WIDTH = 50
  // Bounds for content-derived widths on columns with no explicit setting.
  const AUTO_MIN_WIDTH = 70
  const AUTO_MAX_WIDTH = 320

  /*
    Estimates a sensible width for a column with no explicit width.

    Under table-layout:fixed an undeclared column only receives an equal share
    of the leftover space, so once a few columns claim large pixel widths the
    rest collapse to a few pixels. Sizing them from their own content keeps the
    grid readable while still honouring the widths the user did set.
  */
  function autoWidthFor(name, rows) {
    const CHAR_PX = 7          // ~7px per character at the grid's font size
    const PADDING = 26         // cell padding + sort-arrow allowance
    let longest = String(name == null ? '' : name).length

    // Sampling is enough - scanning thousands of rows to size a column is waste.
    const sample = Math.min(rows.length, 50)
    for (let i = 0; i < sample; i++) {
      const value = rows[i] ? rows[i][name] : ''
      if (value === null || value === undefined) continue
      const len = String(value).length
      if (len > longest) longest = len
    }

    const px = longest * CHAR_PX + PADDING
    return Math.max(AUTO_MIN_WIDTH, Math.min(AUTO_MAX_WIDTH, px))
  }

  /*
    Highlights the hovered column (cells + header) by tagging them with a class.
    Delegated so it survives paging, sorting and redraws, and applied to the
    header's own table too since scrollX renders it separately.
  */
  function attachColumnHover(table) {
    if (!table) return
    const container = $(table.table().container())
    const ns = '.rvcolhover'

    container.off('mouseover' + ns).off('mouseleave' + ns)

    function clearHover() {
      container.find('.rv-col-hover').removeClass('rv-col-hover')
      container.find('.rv-col-hover-head').removeClass('rv-col-hover-head')
    }

    /*
      scrollX splits the grid into a header table and a body table, each with
      their own thead/tbody. Scoping to those two specific tables keeps the
      index consistent - a bare container.find('tbody > tr') also matches the
      header table's rows and highlighted the wrong column.
      mouseover (not mouseenter) so moving between cells always re-evaluates.
    */
    const bodyTable = () => container.find('.dataTables_scrollBody > table').first()
    const headTable = () => container.find('.dataTables_scrollHead table').first()

    container.on('mouseover' + ns, 'td, th', function () {
      const cell = $(this)
      // Ignore cells that aren't part of the grid itself (e.g. child rows).
      const row = cell.parent()
      if (!row.length) return
      const idx = row.children().index(cell)
      if (idx < 0) return

      clearHover()
      bodyTable().find('> tbody > tr').each(function () {
        $(this).children().eq(idx).addClass('rv-col-hover')
      })
      headTable().find('> thead > tr').each(function () {
        $(this).children().eq(idx).addClass('rv-col-hover-head')
      })
    })

    // Only clear when the pointer leaves the whole grid.
    container.on('mouseleave' + ns, clearHover)
  }

  // The column label, read from the wrapper span when present.
  function headerTitle(thEl) {
    const th = $(thEl)
    const span = th.children('.rv-th-text')
    if (span.length) return span.text().trim()
    return th.clone().children('.rv-col-grip').remove().end().text().trim()
  }

  function attachColumnResizers(table, onCommit) {
    if (!table) return
    const wrapper = $(table.table().container())
    const headTable = wrapper.find('.dataTables_scrollHead table').first()
    const headers = headTable.find('thead th')
    if (!headers.length) return

    headers.each(function (index) {
      const th = $(this)
      // Never stack grips if the header is re-rendered.
      th.find('.rv-col-grip').remove()
      th.addClass('rv-resizable-th')

      // Wrap the label so it can ellipsis independently of the th, which must
      // stay overflow:visible for the absolutely-positioned grip.
      if (!th.children('.rv-th-text').length) {
        // Prefer the column's declared title over th.text(), which can include
        // DataTables' sort-order markup.
        let label = ''
        try {
          const settings = table.settings()[0]
          const colIdx = table.column(index).index()
          label = (settings.aoColumns[colIdx] && settings.aoColumns[colIdx].sTitle) || ''
        } catch (e) { /* fall back below */ }
        if (!label) label = th.clone().children().remove().end().text().trim()

        th.contents().filter(function () { return this.nodeType === 3 }).remove()
        th.prepend($('<span class="rv-th-text"></span>').text(label).attr('title', label))
      }

      const grip = $('<span class="rv-col-grip" title="Drag to resize"></span>')
      th.append(grip)

      let startX = 0, startWidth = 0, dragging = false

      grip.on('mousedown', function (e) {
        dragging = true
        startX = e.pageX
        startWidth = th.outerWidth()
        $('body').addClass('rv-col-resizing')
        // Stop the click from triggering a column sort.
        e.preventDefault()
        e.stopPropagation()

        function onMove(ev) {
          if (!dragging) return
          const next = Math.max(MIN_COL_WIDTH, startWidth + (ev.pageX - startX))
          // Live feedback on the header only - the body is reconciled on release
          // so we aren't re-laying out the whole table on every mouse move.
          th.css({ width: next + 'px', minWidth: next + 'px', maxWidth: next + 'px' })
        }

        function onUp(ev) {
          if (!dragging) return
          dragging = false
          $('body').removeClass('rv-col-resizing')
          $(document).off('mousemove.rvcol', onMove).off('mouseup.rvcol', onUp)

          const finalWidth = Math.max(MIN_COL_WIDTH, startWidth + (ev.pageX - startX))
          applyColumnWidth(table, index, finalWidth)
          if (typeof onCommit === 'function') {
            // Pass the index too - matching on the header label is fragile once
            // DataTables adds its own sort markup inside the th.
            onCommit(headerTitle(headers[index]), finalWidth, index)
          }
        }

        $(document).on('mousemove.rvcol', onMove).on('mouseup.rvcol', onUp)
      })

      // Double-click resets the column to auto width.
      grip.on('dblclick', function (e) {
        e.preventDefault()
        e.stopPropagation()
        applyColumnWidth(table, index, 0)
        if (typeof onCommit === 'function') {
          onCommit(headerTitle(headers[index]), 0, index)
        }
      })
    })
  }

  // Pushes a width into the DataTables column definition and redraws so the
  // separate header and body tables end up aligned.
  function applyColumnWidth(table, index, px) {
    try {
      const settings = table.settings()[0]
      const col = settings.aoColumns[index]
      if (!col) return
      const value = px > 0 ? px + 'px' : null
      col.sWidthOrig = value
      // _fnCalculateColumnWidths only re-reads sWidthOrig when sWidth is not
      // null, so both have to be set for the width to take effect.
      col.sWidth = value
      // enforceColumnWidths re-asserts the value after the adjust, which would
      // otherwise recompute it from content.
      enforceColumnWidths(table)
    } catch (e) {
      console.log('applyColumnWidth-> failed :>> ', e && e.message)
    }
  }

  /*
    The `width` column option populates only sWidthOrig (via _fnMap), while
    sWidth defaults to null - and _fnCalculateColumnWidths skips any column
    whose sWidth is null. So a freshly built table ignores the declared widths
    entirely. Seeding sWidth from sWidthOrig after init activates them.
  */
  function primeColumnWidths(table) {
    if (!table) return
    try {
      const settings = table.settings()[0]
      let primed = 0
      settings.aoColumns.forEach(col => {
        if (col.sWidthOrig && col.sWidth === null) {
          col.sWidth = col.sWidthOrig
          primed++
        }
      })
      if (primed > 0) enforceColumnWidths(table)
    } catch (e) {
      console.log('primeColumnWidths-> failed :>> ', e && e.message)
    }
  }

  /*
    Re-asserts declared widths and redraws.
    adjustOneTable() flips bAutoWidth on, which makes DataTables recompute
    sWidth from cell content - discarding any width we set. So the declared
    values are restored from sWidthOrig afterwards and the scroll tables are
    re-sized directly, which is what actually moves the columns on screen.
  */
  /*
    Re-asserts declared widths, then lets DataTables lay the table out itself.

    Manipulating the header/body tables by hand does not work: scrollX keeps two
    separate tables plus internal sizer nodes, and any widths written directly
    end up disagreeing with what DataTables computes - the header ends up wider
    than the body. So the only DOM writes here are to sWidth/sWidthOrig, and
    columns.adjust() is left to apply them everywhere consistently.
  */
  function enforceColumnWidths(table) {
    if (!table) return
    try {
      const settings = table.settings()[0]

      // Restore explicit widths first so the recalculation below honours them
      // (_fnCalculateColumnWidths reads sWidthOrig, but only when sWidth is set).
      settings.aoColumns.forEach(col => {
        if (col.sWidthOrig) col.sWidth = col.sWidthOrig
      })

      // Let DataTables size the header, body and sizer nodes together.
      adjustOneTable(table)

      // The recalculation may have replaced sWidth with a content-derived value.
      // Put the declared ones back and draw once more so they stick.
      let changed = false
      settings.aoColumns.forEach(col => {
        if (col.sWidthOrig && col.sWidth !== col.sWidthOrig) {
          col.sWidth = col.sWidthOrig
          changed = true
        }
      })
      if (changed) {
        try { table.columns.adjust() } catch (e) { /* torn down */ }
      }
    } catch (e) {
      console.log('enforceColumnWidths-> failed :>> ', e && e.message)
    }
  }

  // Applies a column's chosen format to one cell value for display.
  function formatCellByConfig(value, format) {
    if (value === null || value === undefined || value === '') return ''
    if (!format || format === 'none') return $scope.formatCellValue(value)

    const num = Number(value)
    const isNum = !isNaN(num) && value !== true && value !== false

    switch (format) {
      case 'integer':
        return isNum ? String(Math.round(num)) : value
      case 'comma':
        return isNum ? num.toLocaleString('en-US') : value
      case 'currency':
        return isNum ? num.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : value
      case 'percent':
        return isNum ? num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%' : value
      case 'decimal_1':
        return isNum ? num.toFixed(1) : value
      case 'decimal_2':
        return isNum ? num.toFixed(2) : value
      case 'date_mdy':
        return momentSafe(value, 'MM/DD/YYYY')
      case 'date_ymd':
        return momentSafe(value, 'YYYY-MM-DD')
      case 'date_long':
        return momentSafe(value, 'MMM DD, YYYY')
      case 'datetime_mdy':
        return momentSafe(value, 'MM/DD/YYYY HH:mm')
      case 'time_only':
        return momentSafe(value, 'HH:mm:ss')
      case 'upper':
        return String(value).toUpperCase()
      case 'lower':
        return String(value).toLowerCase()
      case 'title':
        return String(value).replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.substr(1).toLowerCase())
      default:
        return $scope.formatCellValue(value)
    }
  }

  // moment is loaded globally; fall back to the raw value if it can't parse.
  function momentSafe(value, mask) {
    if (typeof moment === 'undefined') return value
    const m = moment(value)
    return m.isValid() ? m.format(mask) : value
  }

  // DataTables column defs built from the Fields tab settings.
  function columnsFromConfig(rows) {
    const config = $scope.designer.columns || []
    const names = config.length ? config.filter(c => c.visible !== false).map(c => c.name)
                               : Object.keys(rows[0])
    return names.map(name => {
      const col = config.find(c => c.name === name) || { align: 'left', format: 'none' }
      const align = col.align || 'left'
      const stored = parseInt(col.width, 10) > 0 ? parseInt(col.width, 10) : 0
      // 0 means auto - derive a width from the content so fixed layout cannot
      // collapse the column. The stored value stays 0.
      const width = stored || autoWidthFor(name, rows)
      return {
        width: width + 'px',
        title: name,
        data: name,
        // Applies to header and body cells alike; nowrap was previously set
        // via a _all columnDef, so it has to be carried here now.
        className: `nowrap dt-head-${align} dt-body-${align}`,
        render: function (data, type) {
          if (type === 'display' || type === 'type') return formatCellByConfig(data, col.format)
          return data
        },
        // Truncated cells keep their full value available on hover.
        createdCell: function (td, cellData) {
          const text = td.textContent || ''
          if (text !== '') td.setAttribute('title', text)
        }
      }
    })
  }

  // Two-way hover linking between the SQL editor and the parameters table -----------
  // designer.hoverField holds the placeholder name currently under the cursor
  // (from either side); the table row and the editor text both key off it.
  $scope.designer.hoverField = null

  let editorMarks = []
  let paramTip = null   // single tippy instance, repositioned to the hovered placeholder

  function clearEditorMarks() {
    editorMarks.forEach(mark => mark.clear())
    editorMarks = []
  }

  // Fields tab <-> editor hover linking. Kept in its own mark list so it never
  // interferes with the {{placeholder}} highlighting above.
  let identMarks = []
  $scope.designer.hoverIdent = null   // { kind: 'field'|'table'|'alias', value: <name> }

  function clearIdentMarks() {
    identMarks.forEach(mark => mark.clear())
    identMarks = []
  }

  // Escapes a value for safe use inside a RegExp.
  function reEscape(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  }

  /*
    Marks every standalone occurrence of an identifier in the editor.
    Boundaries are enforced manually so `type` doesn't match inside
    `prop_type`. A dot IS allowed before the name so qualified references
    like p.type still match - excluding it broke the commonest case.
  */
  function markIdentInEditor(name, className) {
    if (!sqlEditor || !name) return 0

    const doc = sqlEditor.getDoc()
    const re = new RegExp('(^|[^A-Za-z0-9_])(' + reEscape(name) + ')(?![A-Za-z0-9_])', 'g')
    const lineCount = doc.lineCount()
    let hits = 0

    for (let line = 0; line < lineCount; line++) {
      const text = doc.getLine(line)
      if (!text) continue
      re.lastIndex = 0
      let m
      while ((m = re.exec(text)) !== null) {
        const start = m.index + m[1].length
        identMarks.push(doc.markText(
          { line: line, ch: start },
          { line: line, ch: start + m[2].length },
          { className: className }
        ))
        hits++
        // Guard against zero-length matches looping forever.
        if (re.lastIndex === m.index) re.lastIndex++
      }
    }
    return hits
  }

  /*
    Highlights a Fields-table row's identifiers in the query.
    Fields (and their aliases) are blue, tables green.
  */
  $scope.hoverFieldRow = function (col, kind) {
    if (!col) return
    clearIdentMarks()

    const value = kind === 'table' ? col.table
      : kind === 'alias' ? col.name
      : col.org_name

    if (!value) {
      $scope.designer.hoverIdent = null
      return
    }

    $scope.designer.hoverIdent = { kind: kind, value: value }
    markIdentInEditor(value, kind === 'table' ? 'rv-cm-table-hit' : 'rv-cm-field-hit')
  }

  // Hovering anywhere on the row lights up field, alias and table together.
  $scope.hoverFieldRowAll = function (col) {
    if (!col) return
    clearIdentMarks()
    $scope.designer.hoverIdent = { kind: 'row', value: col.name }
    if (col.org_name) markIdentInEditor(col.org_name, 'rv-cm-field-hit')
    if (col.aliased && col.name) markIdentInEditor(col.name, 'rv-cm-field-hit')
    if (col.table) markIdentInEditor(col.table, 'rv-cm-table-hit')
  }

  $scope.clearHoverField = function () {
    $scope.designer.hoverIdent = null
    clearIdentMarks()
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;')
  }

  // Tooltip body for one parameter: display name, type, default and required.
  function paramTipHtml(fieldObj) {
    const name = fieldObj.name && String(fieldObj.name).trim() !== '' ? fieldObj.name : '(no display name)'
    const hasDefault = fieldObj.default_value !== '' && fieldObj.default_value !== null && fieldObj.default_value !== undefined
    // Always state required either way - a missing badge is ambiguous.
    const required = fieldObj.required
      ? `<span class="rv-tip-val rv-tip-yes"><i class="fal fa-check"></i> Yes</span>`
      : `<span class="rv-tip-val rv-tip-no"><i class="fal fa-times"></i> No</span>`
    return ''
      + `<div class="rv-tip">`
      + `<div class="rv-tip-name">${escapeHtml(name)}`
      + (fieldObj.unused ? `<span class="rv-tip-unused">unused</span>` : '')
      + `</div>`
      + `<div class="rv-tip-row"><span class="rv-tip-key">Field</span><span class="rv-tip-val rv-tip-mono">${escapeHtml(fieldObj.field)}</span></div>`
      + `<div class="rv-tip-row"><span class="rv-tip-key">Type</span><span class="rv-tip-val">${escapeHtml(fieldObj.type || 'TEXT')}</span></div>`
      + `<div class="rv-tip-row"><span class="rv-tip-key">Default</span>`
      + (hasDefault
        ? `<span class="rv-tip-val rv-tip-mono">${escapeHtml(fieldObj.default_value)}</span>`
        : `<span class="rv-tip-val rv-tip-empty">(none)</span>`)
      + `</div>`
      + `<div class="rv-tip-row"><span class="rv-tip-key">Required</span>${required}</div>`
      + `</div>`
  }

  /*
    Shows the tooltip anchored to the hovered {{placeholder}} in the editor.
    tippy needs a reference rect - the placeholder isn't its own element, so we
    hand it the marked text's bounding box via getReferenceClientRect.
  */
  function showParamTip(fieldObj) {
    if (typeof tippy === 'undefined' || !sqlEditor) return

    const mark = editorMarks[0]
    if (!mark) return
    const range = mark.find()
    if (!range) return

    // Screen coords of the placeholder's start/end.
    const start = sqlEditor.charCoords(range.from, 'window')
    const end = sqlEditor.charCoords(range.to, 'window')
    const rect = {
      width: Math.max(1, end.right - start.left),
      height: Math.max(1, start.bottom - start.top),
      top: start.top, bottom: start.bottom, left: start.left, right: end.right,
    }

    if (!paramTip) {
      paramTip = tippy(document.body, {
        trigger: 'manual',
        allowHTML: true,
        arrow: true,
        placement: 'top',
        theme: 'rv-param',
        offset: [0, 8],
        appendTo: () => document.body,
        interactive: false,
        duration: [90, 60],
      })
    }
    paramTip.setProps({ getReferenceClientRect: () => rect })
    paramTip.setContent(paramTipHtml(fieldObj))
    paramTip.show()
  }

  function hideParamTip() {
    if (paramTip) paramTip.hide()
  }

  // Highlights every {{name}} occurrence of one placeholder inside CodeMirror.
  function markPlaceholderInEditor(name) {
    clearEditorMarks()
    if (!sqlEditor || !name) return

    const doc = sqlEditor.getDoc()
    const needle = `{{${name}}}`
    const lineCount = doc.lineCount()

    for (let line = 0; line < lineCount; line++) {
      const text = doc.getLine(line)
      let from = text.indexOf(needle)
      while (from !== -1) {
        editorMarks.push(doc.markText(
          { line: line, ch: from },
          { line: line, ch: from + needle.length },
          { className: 'rv-cm-param-hit' }
        ))
        from = text.indexOf(needle, from + needle.length)
      }
    }
  }

  // Called from the parameters table (ng-mouseenter / ng-mouseleave).
  $scope.hoverParamRow = function (fieldObj) {
    const name = fieldObj && fieldObj.field ? fieldObj.field : null
    $scope.designer.hoverField = name
    markPlaceholderInEditor(name)
  }

  $scope.clearHoverParam = function () {
    $scope.designer.hoverField = null
    clearEditorMarks()
  }

  // Placeholder name at a CodeMirror position, or null.
  function placeholderAtPos(pos) {
    if (!sqlEditor) return null
    const text = sqlEditor.getDoc().getLine(pos.line)
    if (!text) return null

    const re = /\{\{([A-Za-z0-9_]+)\}\}/g
    let m
    while ((m = re.exec(text)) !== null) {
      if (pos.ch >= m.index && pos.ch <= m.index + m[0].length) return m[1]
    }
    return null
  }

  // Editor -> table. Bound to the CodeMirror wrapper's mousemove.
  function onEditorMouseMove(event) {
    if (!sqlEditor) return
    const pos = sqlEditor.coordsChar({ left: event.clientX, top: event.clientY })
    const name = placeholderAtPos(pos)

    // Placeholder hover (Parameters linking) takes priority.
    if (name !== $scope.designer.hoverField) {
      const fieldObj = ($scope.designer.fields || []).find(f => f.field === name)
      $scope.designer.hoverField = fieldObj ? name : null
      markPlaceholderInEditor($scope.designer.hoverField)
      if (fieldObj) showParamTip(fieldObj)
      else hideParamTip()
      safeApply($scope)
    }

    // Editor -> Fields tab: identifier under the cursor. Skipped while a
    // placeholder is hovered so the two highlights never fight.
    if ($scope.designer.hoverField) {
      if ($scope.designer.hoverIdent) {
        $scope.clearHoverField()
        safeApply($scope)
      }
      return
    }
    updateIdentHover(identAtPos(pos))
  }

  // The bare word under a position, or null. Stops at SQL punctuation so
  // `p.type` yields `type` and `z_users u` yields `z_users`.
  function identAtPos(pos) {
    if (!sqlEditor) return null
    const text = sqlEditor.getDoc().getLine(pos.line)
    if (!text) return null

    const re = /[A-Za-z_][A-Za-z0-9_]*/g
    let m
    while ((m = re.exec(text)) !== null) {
      if (pos.ch >= m.index && pos.ch <= m.index + m[0].length) return m[0]
    }
    return null
  }

  /*
    Resolves a word in the query against the Fields tab and highlights both
    sides: fields/aliases blue, table names green.
  */
  function updateIdentHover(word) {
    const columns = $scope.designer.columns || []
    if (!word || !columns.length) {
      if ($scope.designer.hoverIdent) {
        $scope.clearHoverField()
        safeApply($scope)
      }
      return
    }

    const lower = String(word).toLowerCase()
    let match = null

    // Table name first - a table match is unambiguous.
    const tableCol = columns.find(c => c.table && c.table.toLowerCase() === lower)
    if (tableCol) {
      match = { kind: 'table', value: tableCol.table }
    } else {
      const fieldCol = columns.find(c => (c.org_name && c.org_name.toLowerCase() === lower)
        || (c.name && c.name.toLowerCase() === lower))
      if (fieldCol) match = { kind: 'field', value: word, colName: fieldCol.name }
    }

    const current = $scope.designer.hoverIdent
    if (match && current && current.kind === match.kind && current.value === match.value) return
    if (!match && !current) return

    clearIdentMarks()
    if (!match) {
      $scope.designer.hoverIdent = null
      safeApply($scope)
      return
    }

    $scope.designer.hoverIdent = match
    markIdentInEditor(match.value, match.kind === 'table' ? 'rv-cm-table-hit' : 'rv-cm-field-hit')
    safeApply($scope)
  }

  // True when a Fields row should be highlighted for the current editor hover.
  $scope.isFieldRowHot = function (col) {
    const hover = $scope.designer.hoverIdent
    if (!hover || !col) return false
    if (hover.kind === 'row') return hover.value === col.name
    if (hover.kind === 'table') return !!col.table && col.table === hover.value
    const lower = String(hover.value).toLowerCase()
    return (col.org_name && col.org_name.toLowerCase() === lower)
      || (col.name && col.name.toLowerCase() === lower)
  }

  // Which cell in the row to emphasise.
  $scope.fieldCellHot = function (col, kind) {
    const hover = $scope.designer.hoverIdent
    if (!hover || !$scope.isFieldRowHot(col)) return false
    if (hover.kind === 'row') return false
    if (kind === 'table') return hover.kind === 'table'
    if (hover.kind === 'table') return false
    const lower = String(hover.value).toLowerCase()
    if (kind === 'field') return !!col.org_name && col.org_name.toLowerCase() === lower
    if (kind === 'alias') return !!col.aliased && !!col.name && col.name.toLowerCase() === lower
    return false
  }

  function onEditorMouseLeave() {
    hideParamTip()
    if ($scope.designer.hoverIdent) {
      $scope.designer.hoverIdent = null
      clearIdentMarks()
    }
    if (!$scope.designer.hoverField) {
      safeApply($scope)
      return
    }
    $scope.designer.hoverField = null
    clearEditorMarks()
    safeApply($scope)
  }

  // Collapse / expand the query, parameters and results sections.
  $scope.toggleSection = function (section) {
    $scope.designer.collapsed[section] = !$scope.designer.collapsed[section]

    // CodeMirror renders blank if it was hidden when mounted/resized - refresh
    // it once the section is visible again.
    if (section === 'query' && !$scope.designer.collapsed.query) {
      setTimeout(() => { if (sqlEditor) sqlEditor.refresh() }, 60)
    }
    // DataTables also needs its column widths recalculated after being hidden.
    if (section === 'results' && !$scope.designer.collapsed.results) {
      setTimeout(() => {
        // Via the wrapper - a bare columns.adjust() is a no-op with autoWidth:false.
        adjustOneTable(designerTestTable)
      }, 60)
    }
  }

  // Inline report-name editing -----------------------------------------------------
  $scope.startEditTitle = function () {
    $scope.designer.titleDraft = $scope.designer.title
    $scope.designer.editingTitle = true
    setTimeout(() => {
      const el = document.getElementById('designerTitleInput')
      if (el) { el.focus(); el.select() }
    }, 40)
  }

  // Applies the rename to the working copy - still needs Save to persist.
  /*
    Persists just the title/description. saveReport builds its SET list from
    whatever keys are present, so query/fields/column_config are untouched -
    an in-progress query edit is never written by this.
    Returns true on success.
  */
  async function persistMeta(changes, label) {
    if (!$scope.designer.report) return false
    try {
      const result = await systemService.functionCall({
        type: "saveReport",
        user_id: $scope.user_info ? $scope.user_info.id : null,
        url_password: $scope.user_info ? $scope.user_info.url_password : null,
        // query is required by the server's validation, so send the saved copy
        // rather than the working one - this must not persist query edits.
        report: angular.extend({
          id: $scope.designer.report.id,
          query: $scope.designer.original ? $scope.designer.original.query : $scope.designer.query,
          fields: $scope.designer.report.fields || [],
        }, changes)
      })

      if (!result.data.success) throw result.data.error

      // Keep the sidebar row and the dirty-check baseline in step.
      angular.forEach(changes, function (value, key) {
        $scope.designer.report[key] = value
        if ($scope.designer.original) $scope.designer.original[key] = value
      })

      toastr.success(`${label} saved.`, 'Report Designer', { timeOut: 2000 })
      safeApply($scope)
      return true
    } catch (error) {
      console.log('persistMeta-> error :>> ', error)
      toastr.error(typeof error === 'string' ? error : (error && error.message ? error.message : `Unable to save the ${label.toLowerCase()}.`), 'Report Designer', { timeOut: 8000 })
      safeApply($scope)
      return false
    }
  }

  // Applies the rename and writes it straight to the database.
  $scope.commitEditTitle = async function () {
    const next = ($scope.designer.titleDraft || '').trim()
    if (next === '') {
      toastr.error('The report name cannot be empty.', 'Report Designer')
      return
    }

    const previous = $scope.designer.title
    $scope.designer.title = next
    $scope.designer.editingTitle = false
    safeApply($scope)

    if (next === previous) return
    const saved = await persistMeta({ title: next }, 'Report name')
    if (!saved) {
      // Roll back so the UI doesn't claim a value the database rejected.
      $scope.designer.title = previous
      safeApply($scope)
    }
  }

  $scope.cancelEditTitle = function () {
    $scope.designer.editingTitle = false
    $scope.designer.titleDraft = ''
  }

  // Enter applies, Escape cancels.
  $scope.titleKeydown = function (event) {
    if (event.keyCode === 13) {
      event.preventDefault()
      $scope.commitEditTitle()
    } else if (event.keyCode === 27) {
      event.preventDefault()
      $scope.cancelEditTitle()
    }
  }

  // Delete Report modal ------------------------------------------------------------
  let deleteReportModal = null

  $scope.deleteReport = { confirm: '', deleting: false }

  $scope.openDeleteReportModal = function () {
    if (!$scope.is_admin || !$scope.designer.report) return
    $scope.deleteReport = { confirm: '', deleting: false }
    const el = document.getElementById('deleteReportModal')
    if (!el) return
    deleteReportModal = bootstrap.Modal.getInstance(el) || new bootstrap.Modal(el)
    deleteReportModal.show()
    setTimeout(() => {
      const input = document.getElementById('deleteConfirmInput')
      if (input) input.focus()
    }, 300)
    safeApply($scope)
  }

  $scope.cancelDeleteReport = function () {
    hideDeleteReportModal()
  }

  function hideDeleteReportModal() {
    const el = document.getElementById('deleteReportModal')
    if (!el) return
    const instance = bootstrap.Modal.getInstance(el)
    if (instance) instance.hide()
    safeApply($scope)
  }

  // Enter submits only once the confirmation text is exact.
  $scope.deleteReportKeydown = function (event) {
    if (event.keyCode === 13 && $scope.deleteReport.confirm === 'DELETE') {
      event.preventDefault()
      $scope.confirmDeleteReport()
    }
  }

  /*
    Soft-deletes the report (server sets active = 0), then drops it from the
    sidebar list and closes the designer.
  */
  $scope.confirmDeleteReport = async function () {
    if (!$scope.designer.report) return
    // Belt-and-braces: the button is disabled unless this matches.
    if ($scope.deleteReport.confirm !== 'DELETE') return

    const report = $scope.designer.report
    $scope.deleteReport.deleting = true
    safeApply($scope)

    try {
      const result = await systemService.functionCall({
        type: "deleteReport",
        user_id: $scope.user_info ? $scope.user_info.id : null,
        url_password: $scope.user_info ? $scope.user_info.url_password : null,
        report_id: report.id
      })

      if (!result.data.success) throw result.data.error

      const title = report.title

      // Drop it from the list the sidebar and picker both read from.
      const index = ($scope.reports || []).findIndex(r => r.id === report.id)
      if (index > -1) $scope.reports.splice(index, 1)

      // If it was the report being viewed, clear the results too.
      if ($scope.selectedReport && $scope.selectedReport.id === report.id) {
        $scope.selectedReport = null
        $scope.report_data = null
        if ($scope.dataTable) {
          $scope.dataTable.destroy()
          $('#reportDataTable').empty()
          $scope.dataTable = null
        }
      }

      $scope.deleteReport.deleting = false
      hideDeleteReportModal()

      // Bypass closeDesigner's unsaved-changes prompt - the report is gone, so
      // any pending edits are moot.
      $scope.designer.original = null
      closeDesignerNow()

      toastr.success(`"${title}" deleted.`, 'Report Designer')
      safeApply($scope)
    } catch (error) {
      console.log('confirmDeleteReport-> error :>> ', error)
      toastr.error(typeof error === 'string' ? error : (error && error.message ? error.message : 'Unable to delete the report.'), 'Report Designer', { timeOut: 8000 })
      $scope.deleteReport.deleting = false
      safeApply($scope)
    }
  }

  // Create Report modal ------------------------------------------------------------
  let createReportModal = null

  $scope.newReport = { title: '', description: '', saving: false, showErrors: false }

  $scope.openCreateReportModal = function () {
    if (!$scope.is_admin) return
    $scope.newReport = { title: '', description: '', saving: false, showErrors: false }
    const el = document.getElementById('createReportModal')
    if (!el) return
    createReportModal = bootstrap.Modal.getInstance(el) || new bootstrap.Modal(el)
    createReportModal.show()
    setTimeout(() => {
      const input = document.getElementById('newReportTitle')
      if (input) input.focus()
    }, 300)
    safeApply($scope)
  }

  $scope.cancelCreateReport = function () {
    hideCreateReportModal()
  }

  function hideCreateReportModal() {
    const el = document.getElementById('createReportModal')
    if (!el) return
    const instance = bootstrap.Modal.getInstance(el)
    if (instance) instance.hide()
    safeApply($scope)
  }

  // Enter submits from the name field.
  $scope.createReportKeydown = function (event) {
    if (event.keyCode === 13) {
      event.preventDefault()
      $scope.createReport()
    }
  }

  /*
    Inserts the report, adds it to the sidebar list, then opens it in the
    designer so the user can write the query straight away.
  */
  $scope.createReport = async function () {
    const title = ($scope.newReport.title || '').trim()
    if (title === '') {
      $scope.newReport.showErrors = true
      safeApply($scope)
      return
    }

    $scope.newReport.saving = true
    safeApply($scope)

    try {
      const result = await systemService.functionCall({
        type: "createReport",
        user_id: $scope.user_info ? $scope.user_info.id : null,
        url_password: $scope.user_info ? $scope.user_info.url_password : null,
        report: { title: title, description: ($scope.newReport.description || '').trim() }
      })

      if (!result.data.success) throw result.data.error

      const created = result.data.data
      if (!$scope.reports) $scope.reports = []
      $scope.reports.push(created)

      $scope.newReport.saving = false
      hideCreateReportModal()

      // Open it for editing. The designer reads from $scope.reports by id.
      $scope.openDesigner(created.id)
      toastr.success(`"${created.title}" created.`, 'Report Designer')
    } catch (error) {
      console.log('createReport-> error :>> ', error)
      toastr.error(typeof error === 'string' ? error : (error && error.message ? error.message : 'Unable to create the report.'), 'Report Designer', { timeOut: 8000 })
      $scope.newReport.saving = false
      safeApply($scope)
    }
  }

  // Description modal --------------------------------------------------------------
  $scope.openDescriptionModal = function () {
    $scope.designer.descriptionDraft = $scope.designer.description || ''
    const el = document.getElementById('reportDescriptionModal')
    if (!el) return
    descriptionModal = bootstrap.Modal.getInstance(el) || new bootstrap.Modal(el)
    descriptionModal.show()
    safeApply($scope)
  }

  // Applies to the working copy - still needs Save to persist.
  // Applies the description and writes it straight to the database.
  $scope.saveDescription = async function () {
    const next = ($scope.designer.descriptionDraft || '').trim()
    const previous = $scope.designer.description

    $scope.designer.description = next
    hideDescriptionModal()

    if (next === previous) return
    const saved = await persistMeta({ description: next }, 'Description')
    if (!saved) {
      $scope.designer.description = previous
      safeApply($scope)
    }
  }

  $scope.cancelDescription = function () {
    $scope.designer.descriptionDraft = ''
    hideDescriptionModal()
  }

  function hideDescriptionModal() {
    const el = document.getElementById('reportDescriptionModal')
    if (!el) return
    const instance = bootstrap.Modal.getInstance(el)
    if (instance) instance.hide()
    safeApply($scope)
  }

  $scope.addDesignerField = function () {
    $scope.designer.fields.push({ name: '', field: '', type: 'TEXT', required: false, default_value: '' })
  }

  $scope.removeDesignerField = function (index) {
    const removed = $scope.designer.fields.splice(index, 1)[0]
    if (removed && removed.field) delete $scope.designer.testParams[removed.field]
  }

  // Mounts CodeMirror over the textarea with MySQL highlighting.
  function mountSqlEditor() {
    // The textarea only exists once ng-if has rendered the designer.
    setTimeout(() => {
      const el = document.getElementById('designerSqlEditor')
      if (!el) return

      if (typeof CodeMirror === 'undefined') {
        console.log('mountSqlEditor-> CodeMirror not loaded, falling back to plain textarea')
        return
      }

      // Re-mounting on a new report: reuse the existing instance.
      if (sqlEditor) {
        sqlEditor.setValue($scope.designer.query || '')
        sqlEditor.refresh()
        return
      }

      sqlEditor = CodeMirror.fromTextArea(el, {
        mode: 'text/x-mysql',
        theme: 'idea',
        lineNumbers: true,
        lineWrapping: true,
        matchBrackets: true,
        indentUnit: 2,
        tabSize: 2,
        smartIndent: true,
        // Autocomplete: Ctrl-Space anywhere, and auto-triggered below.
        extraKeys: {
          'Ctrl-Space': function (cm) { maybeAutocomplete(cm) },
          // Prettier's conventional format shortcut.
          'Shift-Alt-F': function () { $scope.formatDesignerQuery() },
        },
        hintOptions: { tables: schemaTables, completeSingle: false },
      })
      sqlEditor.setSize('100%', 260)
      sqlEditor.setValue($scope.designer.query || '')

      // Auto-open the hint list after a "." or a few word characters. Guarded to
      // typing only, so programmatic setValue() never pops the dropdown.
      sqlEditor.on('inputRead', function (cm, change) {
        if (!change || change.origin !== '+input') return
        const typed = change.text && change.text[0]
        if (!typed) return
        if (typed === '.') {
          maybeAutocomplete(cm)
          return
        }
        if (/[A-Za-z0-9_$]/.test(typed)) {
          const cursor = cm.getCursor()
          const upToCursor = (cm.getLine(cursor.line) || '').slice(0, cursor.ch)
          // After a dot, suggest immediately; otherwise wait for 3 characters so
          // the list isn't fighting every keystroke.
          if (/\.[A-Za-z0-9_$]*$/.test(upToCursor) || /[A-Za-z0-9_$]{3,}$/.test(upToCursor)) {
            maybeAutocomplete(cm)
          }
        }
      })

      // Editor -> table hover linking.
      const wrapper = sqlEditor.getWrapperElement()
      wrapper.addEventListener('mousemove', onEditorMouseMove)
      wrapper.addEventListener('mouseleave', onEditorMouseLeave)
      // Scrolling moves the text out from under the tooltip's anchor rect.
      sqlEditor.on('scroll', hideParamTip)

      // Keep the scope model in step with the editor.
      sqlEditor.on('change', function (cm) {
        $scope.designer.query = cm.getValue()
        // Typing invalidates any hover highlight - drop it rather than leaving
        // marks anchored to text that has moved.
        if (editorMarks.length) {
          clearEditorMarks()
          $scope.designer.hoverField = null
          hideParamTip()
        }
        if (identMarks.length) {
          clearIdentMarks()
          $scope.designer.hoverIdent = null
        }
        // Debounced so the table updates once the user pauses, not per keystroke.
        if (syncTimer) clearTimeout(syncTimer)
        syncTimer = setTimeout(() => {
          const added = syncFieldsFromQuery()
          safeApply($scope)
          if (added > 0) {
            toastr.info(`${added} new parameter${added == 1 ? '' : 's'} added from the query.`, 'Parameters', { timeOut: 3000 })
          }
        }, 400)
        safeApply($scope)
      })
      sqlEditor.refresh()
    }, 60)
  }

  function destroySqlEditor() {
    if (sqlEditor) {
      const wrapper = sqlEditor.getWrapperElement()
      if (wrapper) {
        wrapper.removeEventListener('mousemove', onEditorMouseMove)
        wrapper.removeEventListener('mouseleave', onEditorMouseLeave)
      }
      // Marks belong to the doc being torn down - drop our references too.
      editorMarks = []
      identMarks = []
      $scope.designer.hoverField = null
      $scope.designer.hoverIdent = null
      // The tippy instance is attached to document.body, so it outlives the
      // editor unless destroyed explicitly.
      if (paramTip) {
        paramTip.destroy()
        paramTip = null
      }
      sqlEditor.toTextArea()
      sqlEditor = null
    }
  }

  function destroyDesignerTestTable() {
    if (designerTestTable) {
      designerTestTable.destroy()
      $('#designerTestTable').empty()
      designerTestTable = null
    }
  }

  // Runs the edited SQL with the test values and renders the rows below.
  $scope.testDesignerQuery = async function () {
    if (!$scope.designer.report) return

    /*
      A test run is prompted for its parameters just like a live one, through
      the same modal - but seeded from the Test Value column, falling back to
      the Default Value where no test value is set. Read straight off the live
      query rather than the `unused` flags, which lag the editor by 400ms.
    */
    const inQuery = placeholdersInQuery($scope.designer.query)
    const active = ($scope.designer.fields || []).filter(f => f.field && inQuery.indexOf(f.field) !== -1)

    if (active.length > 0) {
      const values = {}
      active.forEach(f => {
        const test = $scope.designer.testParams[f.field]
        values[f.field] = seedParamValue(
          f,
          (test === undefined || test === null || test === '') ? f.default_value : test
        )
      })

      // The prompt drives reportParameters, which belongs to the live report
      // run - a test must not leave its values behind in the export header.
      const priorParameters = $scope.reportParameters

      let entered
      try {
        entered = await promptForParameters({
          title: ($scope.designer.title || 'Report') + ' - Test Parameters',
          intro: 'Pre-filled with each parameter\'s Test Value, or its Default Value where none is set.',
          submitLabel: 'Run Test',
          fields: active,
          values: values,
        })
      } catch (e) {
        console.log('testDesignerQuery-> parameter prompt closed :>> ', e)
        $scope.reportParameters = priorParameters
        return
      }

      // Keep the Test Value column showing what the run actually used.
      active.forEach(f => { $scope.designer.testParams[f.field] = entered[f.field] })
      $scope.reportParameters = priorParameters
    }

    $scope.designer.testing = true
    $scope.designer.testError = null
    $scope.designer.testInfo = null
    safeApply($scope)

    // Only send params that the query actually declares, coercing by type.
    const params = {}
    $scope.designer.fields.forEach(f => {
      if (!f.field) return
      let value = $scope.designer.testParams[f.field]
      if (value === undefined || value === null || value === '') value = f.default_value
      if ((f.type === 'INT' || f.type === 'DBL') && value !== '' && value !== null && value !== undefined) {
        const num = Number(value)
        value = isNaN(num) ? value : num
      }
      params[f.field] = value
    })

    try {
      const result = await systemService.functionCall({
        type: "reporting_query_sql",
        query: $scope.designer.query,
        params: params,
        include_meta: true      // drives the Fields tab
      })

      destroyDesignerTestTable()

      if (!result.data.success) {
        const err = result.data.error
        $scope.designer.testError = (err && (err.sqlMessage || err.message)) ? (err.sqlMessage || err.message) : String(err)
        $scope.designer.testData = null
        $scope.designer.testRan = true
        $scope.designer.testing = false
        safeApply($scope)
        return
      }

      // With include_meta the payload is { rows, columns, ... }; without it, a
      // plain array. `notice` explains a CALL / multi-statement result - the
      // server has already reduced those to the one result set shown here.
      const payload = result.data.data || []
      const rows = Array.isArray(payload) ? payload : (payload.rows || [])
      const metaColumns = Array.isArray(payload) ? null : (payload.columns || [])
      const notice = Array.isArray(payload) ? null : payload.notice

      // Reconcile the Fields tab against what the query actually returned,
      // preserving any alignment/format the user already set.
      if (metaColumns) {
        $scope.designer.columns = mergeColumnConfig(metaColumns, $scope.designer.columns)
      }

      $scope.designer.testData = rows
      $scope.designer.testRan = true
      $scope.designer.testInfo = `${rows.length} row${rows.length == 1 ? '' : 's'} returned.`
      if (notice) $scope.designer.testInfo += ' ' + notice
      $scope.designer.testing = false
      safeApply($scope)

      if (rows.length > 0) {
        setTimeout(() => {
          const columns = columnsFromConfig(rows)
          designerTestTable = $('#designerTestTable').DataTable({
            data: rows,
            columns: columns,
            responsive: false,
            scrollX: true,
            scrollCollapse: true,
            paging: true,
            pageLength: 10,
            lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
            searching: true,
            ordering: true,
            info: true,
            autoWidth: false,
            dom: '<"top"<"dt-top-left"lB><"dt-top-right"f>>rt<"bottom"ip>',
            buttons: exportButtons(
              () => ($scope.designer.title || 'Report') + ' (test)',
              function () {
                const info = designerTestTable ? designerTestTable.page.info() : null
                return {
                  description: $scope.designer.description || '',
                  rows: info ? info.recordsDisplay : 0,
                  totalRows: info ? info.recordsTotal : 0,
                  filtered: !!(info && info.recordsDisplay !== info.recordsTotal),
                  columns: designerTestTable ? designerTestTable.columns(':visible').count() : 0,
                  // Test values used for this run.
                  parameters: ($scope.designer.fields || [])
                    .filter(f => f.field && !f.unused)
                    .map(f => ({
                      name: f.name || f.field,
                      value: $scope.designer.testParams[f.field],
                    }))
                    .filter(pm => pm.value !== undefined && pm.value !== null && pm.value !== ''),
                }
              }
            ),
            // No _all className here - it would replace the per-column
            // dt-head-*/dt-body-* alignment classes set in columnsFromConfig.
          })

          // Declared widths need sWidth seeding before they take effect.
          primeColumnWidths(designerTestTable)
          attachColumnHover(designerTestTable)

          // Drag-to-resize; the new width is written back to the Fields tab.
          attachColumnResizers(designerTestTable, function (columnName, px, index) {
            // Resolve by visible index first; the header label can pick up
            // DataTables' own sort markup and fail an exact name match.
            const visible = ($scope.designer.columns || []).filter(c => c.visible !== false)
            const col = visible[index] || visible.find(c => c.name === columnName)
            if (!col) {
              console.log('resize commit-> column not matched :>> ', columnName, index)
              return
            }
            col.width = px
            safeApply($scope)
          })
        }, 100)
      }
    } catch (error) {
      console.log('testDesignerQuery-> error :>> ', error)
      $scope.designer.testError = error && error.message ? error.message : 'Unable to run the test query.'
      $scope.designer.testRan = true
      $scope.designer.testing = false
      safeApply($scope)
    }
  }

  // Persists query + fields back to z_reports (server re-checks access_level).
  $scope.saveDesignerReport = async function () {
    // Returns true/false so callers (e.g. the unsaved-changes prompt) can
    // tell whether it is safe to continue.
    if (!$scope.designer.report) return false
    if (!$scope.designerIsDirty()) return true

    // Every parameter needs a placeholder name to be substitutable.
    const unnamed = $scope.designer.fields.filter(f => !f.field || String(f.field).trim() === '')
    if (unnamed.length > 0) {
      toastr.error('Every parameter needs a Field (placeholder) value.', 'Report Designer')
      return false
    }

    if (!$scope.designer.title || $scope.designer.title.trim() === '') {
      toastr.error('The report name cannot be empty.', 'Report Designer')
      return false
    }

    $scope.designer.saving = true
    safeApply($scope)

    try {
      const result = await systemService.functionCall({
        type: "saveReport",
        user_id: $scope.user_info ? $scope.user_info.id : null,
        url_password: $scope.user_info ? $scope.user_info.url_password : null,
        report: {
          id: $scope.designer.report.id,
          query: $scope.designer.query,
          fields: $scope.designer.fields,
          title: $scope.designer.title,
          description: $scope.designer.description,
          column_config: cloneColumns($scope.designer.columns),
        }
      })

      if (!result.data.success) throw result.data.error

      // Reflect the saved state locally so the sidebar/report run uses it too.
      $scope.designer.report.query = $scope.designer.query
      $scope.designer.report.fields = cloneFields($scope.designer.fields)
      $scope.designer.report.title = $scope.designer.title
      $scope.designer.report.description = $scope.designer.description
      $scope.designer.report.column_config = cloneColumns($scope.designer.columns)
      $scope.designer.original = {
        query: $scope.designer.query,
        fields: angular.toJson(cloneFields($scope.designer.fields)),
        title: $scope.designer.title,
        description: $scope.designer.description,
        columns: angular.toJson(cloneColumns($scope.designer.columns)),
      }

      toastr.success('Report saved.', 'Report Designer')
      $scope.designer.saving = false
      safeApply($scope)
      return true
    } catch (error) {
      console.log('saveDesignerReport-> error :>> ', error)
      toastr.error(typeof error === 'string' ? error : (error && error.message ? error.message : 'Unable to save the report.'), 'Report Designer', { timeOut: 8000 })
      $scope.designer.saving = false
      safeApply($scope)
      return false
    }
  }

  //#endregion Report Designer

  init()
  async function init() {
    $scope.loading = true
    $scope.county_list = await systemService.functionCall({ type: "countyList", active_only: false })
    console.log('$scope.county_list :>> ', $scope.county_list)
    let taxYearResults = await systemService.functionCall({ type: "getCurrentTaxYear" })
    $scope.tax_year = taxYearResults.data.data
    console.log('$scope.tax_year :>> ', $scope.tax_year);

    const _reports = await systemService.functionCall({ type: "getReportList", active_only: true })
    $scope.reports = _reports.data.data
    console.log('$scope.reports :>> ', $scope.reports)

    $scope.selectedReport = null
    $scope.loading = false
    safeApply($scope)
  }

  $scope.selectReport = function (reportId) {
    // Guarded here as well as in the template: running a report replaces the
    // panel contents and would strand in-progress designer edits.
    if ($scope.designerIsOpen()) {
      toastr.info('Close the designer to run a report.', 'Report Designer', { timeOut: 3000 })
      return
    }

    const report = $scope.reports[reportId]
    console.log('report :>> ', report)
    if (!report) {
      console.error('Report not found:', reportId)
      return
    }

    $scope.selectedReport = report

    // Only ask for parameters the query will actually use. A report with none
    // - or whose declared params are all unused - runs straight through.
    const fields = activeReportFields(report)
    if (fields.length === 0) {
      // Don't let the previous report's values linger in the export header.
      $scope.reportParameters = {}
      runReport(report, {})
      return
    }

    const values = {}
    fields.forEach(f => { values[f.field] = seedParamValue(f, f.default_value) })

    promptForParameters({
      title: (report.title || 'Report') + ' Parameters',
      intro: 'Review the values below, then run the report.',
      submitLabel: 'Run Report',
      fields: fields,
      values: values,
    }).then(params => {
      runReport(report, params)
    }).catch(err => {
      console.log('selectReport-> parameter prompt closed :>> ', err)
      $scope.loading = false
      safeApply($scope)
    })
  }

  function runReport(report, params) {
    $scope.loading = true
    safeApply($scope)

    switch (report.query_type.toUpperCase()) {
      case 'SQL': // Handle SQL report
        query_sql(report, params).then(data => {
          console.log('SQL report data :>> ', data)
          $scope.report_data = data

          // Initialize DataTable after data is loaded
          setTimeout(() => {
            initializeDataTable(data);
          }, 100);

          $scope.loading = false
          safeApply($scope)
        }).catch(err => {
          console.error('Error running report:', err)
          $scope.loading = false
          safeApply($scope)
        })
        break
      default:
        $scope.loading = false
        safeApply($scope)
        break
    }
  }

  // Parameter prompt ---------------------------------------------------------------
  //#region - Parameter prompt

  /*
    The parameters a report will actually use.

    z_reports.fields can hold placeholders the query no longer references - the
    designer flags those as "unused" and deliberately keeps them rather than
    deleting them - and substituting one changes nothing, so there is no point
    asking for it. A report whose declared params are all unused runs straight
    through with no prompt.
  */
  function activeReportFields(report) {
    if (!report) return []

    // z_reports.fields is a JSON column - may arrive as an array or a string.
    let fields = report.fields
    if (typeof fields === 'string') {
      try { fields = JSON.parse(fields) } catch (e) { fields = [] }
    }
    if (!Array.isArray(fields)) return []

    // Without a query there is nothing to match against - ask for everything
    // declared rather than silently running with no values.
    if (!report.query) return fields.filter(f => f && f.field)

    const inQuery = placeholdersInQuery(report.query)
    return fields.filter(f => f && f.field && inQuery.indexOf(f.field) !== -1)
  }

  /*
    Coerces a stored value into what the matching input expects.
    AngularJS binds input[type=number] to a Number and input[type=date] to a
    Date; hand either one a string and ngModel throws a format error and leaves
    the field blank - defeating the whole point of pre-filling it. Dates are
    converted separately, into paramPrompt.dates.
  */
  function seedParamValue(fieldObj, raw) {
    if (raw === undefined || raw === null || raw === '') return null
    if (fieldObj.type === 'INT' || fieldObj.type === 'DBL') {
      const num = Number(raw)
      return isNaN(num) ? null : num
    }
    return raw
  }

  // 'YYYY-MM-DD' -> Date. Built in local time: new Date('2025-01-31') is UTC
  // midnight, which renders as the 30th anywhere west of Greenwich.
  function toDateModel(value) {
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value
    const m = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(String(value == null ? '' : value))
    if (!m) return null
    const date = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    return isNaN(date.getTime()) ? null : date
  }

  // Date -> 'YYYY-MM-DD', the form the query placeholders are substituted with.
  function fromDateModel(date) {
    if (!(date instanceof Date) || isNaN(date.getTime())) return null
    const pad = n => (n < 10 ? '0' + n : String(n))
    return date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate())
  }

  /*
    Holds everything the modal renders. reportParameters stays the single
    source of truth for the values themselves (the export/print header reads it
    to show what the report was run with); dates mirrors the DATE fields as
    Date objects purely so input[type=date] can bind to them.
  */
  $scope.paramPrompt = {
    title: 'Parameters',
    intro: '',
    submitLabel: 'Run Report',
    fields: [],
    dates: {},
  }

  // Date inputs write back through here so reportParameters keeps the string.
  $scope.onParamDateChange = function (fieldObj) {
    $scope.reportParameters[fieldObj.field] = fromDateModel($scope.paramPrompt.dates[fieldObj.field])
  }

  // True when a value counts as "empty" for required-field purposes.
  function isEmptyValue(val) {
    return val === null || val === undefined || (typeof val === 'string' && val.trim() === '')
  }

  // Required fields that are still empty - blocks the run button.
  $scope.missingRequiredFields = function () {
    return ($scope.paramPrompt.fields || []).filter(function (f) {
      return f.required && isEmptyValue($scope.reportParameters[f.field])
    })
  }
  $scope.hasMissingRequired = function () {
    return $scope.missingRequiredFields().length > 0
  }
  // Per-field flag used by the template to show inline errors.
  $scope.isFieldInvalid = function (fieldObj) {
    return !!fieldObj.required && isEmptyValue($scope.reportParameters[fieldObj.field])
  }

  /*
    Prompts for parameter values before a run and resolves with them; rejects
    when the user backs out (Cancel, the X, ESC or a backdrop click).

    The inputs are shown pre-populated rather than blank - the caller resolves
    each starting value: the saved Default Value when viewing a report, the
    designer's Test Value (falling back to the default) when editing one.
  */
  function promptForParameters(opts) {
    return new Promise((resolve, reject) => {
      const modalElement = document.getElementById('reportParameterModal')
      if (!modalElement) {
        console.log('promptForParameters-> modal element not found in the DOM')
        reject('Modal element not found')
        return
      }

      const fields = opts.fields || []

      $scope.paramPrompt = {
        title: opts.title || 'Parameters',
        intro: opts.intro || 'Review the values below, then run the report.',
        submitLabel: opts.submitLabel || 'Run Report',
        fields: fields,
        dates: {},
      }

      $scope.reportParameters = {}
      $scope.showParamErrors = false
      fields.forEach(f => {
        const value = seedParamValue(f, opts.values ? opts.values[f.field] : f.default_value)
        $scope.reportParameters[f.field] = value
        if (f.type === 'DATE') $scope.paramPrompt.dates[f.field] = toDateModel(value)
      })

      let bsModal = null
      try {
        if (typeof bootstrap !== 'undefined') {
          bsModal = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement)
          bsModal.show()
        }
      } catch (err) {
        console.log('promptForParameters-> error showing modal :>> ', err)
        reject('Error showing modal: ' + err.message)
        return
      }

      let settled = false

      function hide() {
        try {
          if (bsModal) bsModal.hide()
          else if (typeof $ !== 'undefined' && $.fn.modal) $(modalElement).modal('hide')
        } catch (e) {
          console.log('promptForParameters-> error hiding modal :>> ', e)
        }
      }

      /*
        ESC and backdrop clicks bypass both buttons. Without settling here the
        caller waits forever - which in the designer would leave the Test
        button spinning with no way back.
      */
      $(modalElement).one('hidden.bs.modal', function () {
        if (settled) return
        settled = true
        reject('User cancelled')
        safeApply($scope)
      })

      $scope.submitParameters = function () {
        // Block submission while any required field is empty.
        if ($scope.hasMissingRequired()) {
          $scope.showParamErrors = true
          return
        }
        settled = true
        hide()
        resolve($scope.reportParameters)
      }

      $scope.cancelParameters = function () {
        settled = true
        hide()
        reject('User cancelled')
      }

      safeApply($scope)
    })
  }

  //#endregion Parameter prompt

  async function query_sql(report, params) {
    const result = await systemService.functionCall({
      type: "reporting_query_sql",
      query: report.query,
      params: params || {}
    })

    // Add debugging to see the structure
    console.log('Raw SQL result:', result)

    // Process the data to ensure it has the expected format
    const processedData = result.data

    // If data exists but columns aren't explicitly defined, extract them from the first row
    if (processedData && processedData.data && processedData.data.length > 0 && !processedData.columns) {
      processedData.columns = Object.keys(processedData.data[0])
      console.log('Extracted columns:', processedData.columns)
    }

    return processedData
  }
})
